//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v14.7.1.0 (NJsonSchema v11.6.1.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* eslint-disable */
// ReSharper disable InconsistentNaming

import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';

import moment from 'moment';

export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export interface IAcademicPartnersClient {
    /**
     * Gets all academic partners. The parameter includeInactive defines if inactive
    academic partners are included in the result or not.
     * @param includeInactive true if inactive academic partners should be included, false if not
     * @return An AcademicPartnerListResult object containing the requested academic partners
     */
    get(includeInactive: boolean): Observable<AcademicPartnerListResult>;
    /**
     * Insert list of academic partners to database
     * @param model Data model
     * @return Inserted list
     */
    insertList(model: InsertAcademicPartnerModel[]): Observable<AcademicPartnerListResult>;
    /**
     * Update list of academic partners in database
     * @param model Data model
     * @return Updated list
     */
    updateList(model: AcademicPartnerModel[]): Observable<AcademicPartnerListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class AcademicPartnersClient implements IAcademicPartnersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all academic partners. The parameter includeInactive defines if inactive
    academic partners are included in the result or not.
     * @param includeInactive true if inactive academic partners should be included, false if not
     * @return An AcademicPartnerListResult object containing the requested academic partners
     */
    get(includeInactive: boolean): Observable<AcademicPartnerListResult> {
        let url_ = this.baseUrl + "/api/AcademicPartners/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicPartnerListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicPartnerListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<AcademicPartnerListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcademicPartnerListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Insert list of academic partners to database
     * @param model Data model
     * @return Inserted list
     */
    insertList(model: InsertAcademicPartnerModel[]): Observable<AcademicPartnerListResult> {
        let url_ = this.baseUrl + "/api/AcademicPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicPartnerListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicPartnerListResult>;
        }));
    }

    protected processInsertList(response: HttpResponseBase): Observable<AcademicPartnerListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcademicPartnerListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update list of academic partners in database
     * @param model Data model
     * @return Updated list
     */
    updateList(model: AcademicPartnerModel[]): Observable<AcademicPartnerListResult> {
        let url_ = this.baseUrl + "/api/AcademicPartners";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<AcademicPartnerListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<AcademicPartnerListResult>;
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<AcademicPartnerListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = AcademicPartnerListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IBlackListClient {
    /**
     * Send the blacklist report to management
     * @return true if the email could properly be sent, false if not
     */
    sendBlackListReportToApprover(): Observable<DefaultRequestResult>;
    /**
     * Send the blacklist report to all advisors concerned
     * @return true if the emails could properly be sent, false if not
     */
    sendBlackListReportToAdvisor(): Observable<DefaultRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class BlackListClient implements IBlackListClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Send the blacklist report to management
     * @return true if the email could properly be sent, false if not
     */
    sendBlackListReportToApprover(): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/BlackList/sendblacklisttoapprover";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBlackListReportToApprover(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBlackListReportToApprover(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processSendBlackListReportToApprover(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Send the blacklist report to all advisors concerned
     * @return true if the emails could properly be sent, false if not
     */
    sendBlackListReportToAdvisor(): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/BlackList/sendblacklisttoadvisor";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendBlackListReportToAdvisor(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendBlackListReportToAdvisor(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processSendBlackListReportToAdvisor(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IClientSettingClient {
    /**
     * Implementation of GET: api/<controller>
     * @return Client settings to be used on authentication
     */
    get(): Observable<ClientSettingModel>;
}

@Injectable({
    providedIn: 'root'
})
export class ClientSettingClient implements IClientSettingClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Implementation of GET: api/<controller>
     * @return Client settings to be used on authentication
     */
    get(): Observable<ClientSettingModel> {
        let url_ = this.baseUrl + "/api/ClientSetting";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ClientSettingModel>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ClientSettingModel>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ClientSettingModel> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ClientSettingModel.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ICostsClient {
    /**
     * You get all costs to the project with the values of 4 years starting from the current year
     * @param projectId the id from request project
     */
    getForProject(projectId: number): Observable<ProjectCostResult>;
    /**
     * You generate a empty Value for Cost Planning and CostAccount with the values of 4 years starting from the current year
     * @param projectId (optional) 
     */
    createEmptyEditValues(projectId: number | undefined): Observable<ProjectCostResult>;
    /**
     * You can use it to update the transferred values in the database.
     * @param items objects with the cost account to updated
     */
    updateListAccounts(items: CostAccountModel[]): Observable<CostAccountListResult>;
    /**
     * You can use it to update the transferred values in the database.
     * @param projectId (optional) project id, in case a new cost item has to be created
     * @param items objects with the cost amount to updated
     */
    updateListAmounts(projectId: number | undefined, items: CostAmountModel[]): Observable<CostAmountListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class CostsClient implements ICostsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * You get all costs to the project with the values of 4 years starting from the current year
     * @param projectId the id from request project
     */
    getForProject(projectId: number): Observable<ProjectCostResult> {
        let url_ = this.baseUrl + "/api/Costs/costs/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCostResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCostResult>;
        }));
    }

    protected processGetForProject(response: HttpResponseBase): Observable<ProjectCostResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCostResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * You generate a empty Value for Cost Planning and CostAccount with the values of 4 years starting from the current year
     * @param projectId (optional) 
     */
    createEmptyEditValues(projectId: number | undefined): Observable<ProjectCostResult> {
        let url_ = this.baseUrl + "/api/Costs/costs/emptyEditValues?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processCreateEmptyEditValues(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processCreateEmptyEditValues(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectCostResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectCostResult>;
        }));
    }

    protected processCreateEmptyEditValues(response: HttpResponseBase): Observable<ProjectCostResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectCostResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * You can use it to update the transferred values in the database.
     * @param items objects with the cost account to updated
     */
    updateListAccounts(items: CostAccountModel[]): Observable<CostAccountListResult> {
        let url_ = this.baseUrl + "/api/Costs/costs/accounts";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateListAccounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListAccounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostAccountListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostAccountListResult>;
        }));
    }

    protected processUpdateListAccounts(response: HttpResponseBase): Observable<CostAccountListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostAccountListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * You can use it to update the transferred values in the database.
     * @param projectId (optional) project id, in case a new cost item has to be created
     * @param items objects with the cost amount to updated
     */
    updateListAmounts(projectId: number | undefined, items: CostAmountModel[]): Observable<CostAmountListResult> {
        let url_ = this.baseUrl + "/api/Costs/costs/amounts?";
        if (projectId === null)
            throw new globalThis.Error("The parameter 'projectId' cannot be null.");
        else if (projectId !== undefined)
            url_ += "projectId=" + encodeURIComponent("" + projectId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(items);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateListAmounts(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateListAmounts(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<CostAmountListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<CostAmountListResult>;
        }));
    }

    protected processUpdateListAmounts(response: HttpResponseBase): Observable<CostAmountListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = CostAmountListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IEnBWUnitsClient {
    /**
     * Read EnBW units
     * @param includeInactive If true, inculde units that were marked as inactive
     * @return List of EnBW units
     */
    get(includeInactive: boolean): Observable<EnBWUnitListResult>;
    /**
     * Insert list of EnBW units
     * @param model List of EnBW units to be inserted
     * @return List of inserted EnBW units
     */
    insertList(model: InsertEnBWUnitModel[]): Observable<EnBWUnitListResult>;
    /**
     * Update list of EnBW units
     * @param model List of EnBW units to be updated
     * @return List of updated EnBW units
     */
    updateList(model: EnBWUnitModel[]): Observable<EnBWUnitListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class EnBWUnitsClient implements IEnBWUnitsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Read EnBW units
     * @param includeInactive If true, inculde units that were marked as inactive
     * @return List of EnBW units
     */
    get(includeInactive: boolean): Observable<EnBWUnitListResult> {
        let url_ = this.baseUrl + "/api/EnBWUnits/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnBWUnitListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnBWUnitListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<EnBWUnitListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnBWUnitListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Insert list of EnBW units
     * @param model List of EnBW units to be inserted
     * @return List of inserted EnBW units
     */
    insertList(model: InsertEnBWUnitModel[]): Observable<EnBWUnitListResult> {
        let url_ = this.baseUrl + "/api/EnBWUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnBWUnitListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnBWUnitListResult>;
        }));
    }

    protected processInsertList(response: HttpResponseBase): Observable<EnBWUnitListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnBWUnitListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Update list of EnBW units
     * @param model List of EnBW units to be updated
     * @return List of updated EnBW units
     */
    updateList(model: EnBWUnitModel[]): Observable<EnBWUnitListResult> {
        let url_ = this.baseUrl + "/api/EnBWUnits";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<EnBWUnitListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<EnBWUnitListResult>;
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<EnBWUnitListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = EnBWUnitListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IHelpToolTipClient {
    /**
     * Gets all HelpToolTips.
     * @return An HelpToolTipListResult object containing the requested academic partners
     */
    get(): Observable<HelpToolTipListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class HelpToolTipClient implements IHelpToolTipClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Gets all HelpToolTips.
     * @return An HelpToolTipListResult object containing the requested academic partners
     */
    get(): Observable<HelpToolTipListResult> {
        let url_ = this.baseUrl + "/api/HelpToolTip";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<HelpToolTipListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<HelpToolTipListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<HelpToolTipListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = HelpToolTipListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ILogbooksClient {
    /**
     * Returns all tags from the database, ordered by name
     * @return A LogbookListResult object containing the list of logbook items
     */
    get(projectId: number): Observable<LogbookListResult>;
    /**
     * Inserts logbook entries into the database
     * @param models The logbook entries to add to the database
     * @return A LogbookListResult object containing the added logbook entries
     */
    insertList(models: InsertLogbookModel[]): Observable<LogbookListResult>;
    /**
     * Updates multiple logbook entries in the database
     * @param models The logbook entries to update in the database
     * @return A LogbookListResult object containing the updated logbook entries
     */
    updateList(models: UpdateLogbookModel[]): Observable<LogbookListResult>;
    /**
     * Deletes logbook entries with the provided ids from the database
     * @param logbookIds The ids of the logbook entries to delete as a list/an array of int
     * @return A DefaultRequestResult object with the result of the operation
     */
    deleteList(logbookIds: number[]): Observable<DefaultRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class LogbooksClient implements ILogbooksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all tags from the database, ordered by name
     * @return A LogbookListResult object containing the list of logbook items
     */
    get(projectId: number): Observable<LogbookListResult> {
        let url_ = this.baseUrl + "/api/Logbooks/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogbookListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogbookListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<LogbookListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogbookListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inserts logbook entries into the database
     * @param models The logbook entries to add to the database
     * @return A LogbookListResult object containing the added logbook entries
     */
    insertList(models: InsertLogbookModel[]): Observable<LogbookListResult> {
        let url_ = this.baseUrl + "/api/Logbooks/insertList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogbookListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogbookListResult>;
        }));
    }

    protected processInsertList(response: HttpResponseBase): Observable<LogbookListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogbookListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates multiple logbook entries in the database
     * @param models The logbook entries to update in the database
     * @return A LogbookListResult object containing the updated logbook entries
     */
    updateList(models: UpdateLogbookModel[]): Observable<LogbookListResult> {
        let url_ = this.baseUrl + "/api/Logbooks/updateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<LogbookListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<LogbookListResult>;
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<LogbookListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = LogbookListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes logbook entries with the provided ids from the database
     * @param logbookIds The ids of the logbook entries to delete as a list/an array of int
     * @return A DefaultRequestResult object with the result of the operation
     */
    deleteList(logbookIds: number[]): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Logbooks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(logbookIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IMilestonesClient {
    /**
     * Returns all milestones for a project from the database, unordered
     * @param projectId The id of the project to geth the milestones for
     * @return A MilestoneListResult object containing the list of milestones
     */
    get(projectId: number): Observable<MilestoneListResult>;
    /**
     * Inserts milestones into the database
     * @param models The milestones to add to the database
     * @return A MilestoneListResult object containing the added milestones
     */
    insertList(models: MilestoneModel[]): Observable<MilestoneListResult>;
    /**
     * Updates multiple milestones in the database
     * @param models The milestones to update in the database
     * @return A MilestoneListResult object containing the updated milestones
     */
    updateList(models: MilestoneModel[]): Observable<MilestoneListResult>;
    /**
     * Deletes the milestones with the provided ids from the database
     * @param milestoneIds The ids of the milestones to delete in the database
     * @return A DefaultRequestResult with the result of the operation
     */
    deleteList(milestoneIds: string): Observable<DefaultRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class MilestonesClient implements IMilestonesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all milestones for a project from the database, unordered
     * @param projectId The id of the project to geth the milestones for
     * @return A MilestoneListResult object containing the list of milestones
     */
    get(projectId: number): Observable<MilestoneListResult> {
        let url_ = this.baseUrl + "/api/Milestones/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MilestoneListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MilestoneListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<MilestoneListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MilestoneListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inserts milestones into the database
     * @param models The milestones to add to the database
     * @return A MilestoneListResult object containing the added milestones
     */
    insertList(models: MilestoneModel[]): Observable<MilestoneListResult> {
        let url_ = this.baseUrl + "/api/Milestones/insertList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MilestoneListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MilestoneListResult>;
        }));
    }

    protected processInsertList(response: HttpResponseBase): Observable<MilestoneListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MilestoneListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates multiple milestones in the database
     * @param models The milestones to update in the database
     * @return A MilestoneListResult object containing the updated milestones
     */
    updateList(models: MilestoneModel[]): Observable<MilestoneListResult> {
        let url_ = this.baseUrl + "/api/Milestones/updateList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<MilestoneListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<MilestoneListResult>;
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<MilestoneListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = MilestoneListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the milestones with the provided ids from the database
     * @param milestoneIds The ids of the milestones to delete in the database
     * @return A DefaultRequestResult with the result of the operation
     */
    deleteList(milestoneIds: string): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Milestones/deleteList";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(milestoneIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectsClient {
    /**
     * Returns the list of projects from the database
     * @return A ProjectListResult object containing the list of project states
     */
    getList(): Observable<ProjectListResult>;
    /**
     * Inserts a single project into the database
     * @param model The model of the project to insert into the database
     * @return A ProjectResult object with the data of the inserted project
     */
    insert(model: InsertProjectModel): Observable<ProjectResult>;
    /**
     * Updates a project in the database
     * @param model The model with the data to update the project with
     * @return A ProjectResult object with the data of the updated project
     */
    update(model: UpdateProjectModel): Observable<ProjectResult>;
    /**
     * Returns the project overview from the database. The overview contains a list of projects and the statistic
    data (active project count, planned project count, closed project count, for the current year)
    Since a body can not be provided for get methods, this method is provided as post.
     * @return A ProjectOverviewResult object containing the overview of projects
     */
    getOverviewPOST(model: ProjectFilterModel): Observable<ProjectOverviewResult>;
    /**
     * Returns the project overview from the database. The overview contains a list of projects and the statistic
    data (active project count, planned project count, closed project count, for the current year)
     * @return A ProjectOverviewResult object containing the overview of projects
     */
    getOverviewGET(): Observable<ProjectOverviewResult>;
    /**
     * Returns a single project from the database (e.g. for editing or displaying)
     * @param id The id of the project to retrieve from the database
     * @return A ProjectResult object containing the requested project
     */
    get(id: number): Observable<ProjectResult>;
    /**
     * Deletes a project from the database
     * @param id The id of the project to delete
     * @return A DefaultRequestResult object with the result of the operation
     */
    delete(id: number): Observable<DefaultRequestResult>;
    /**
     * Assigns users to a project. The user ids need to be provided as a comma separated string and must be
    of type int. The ids are parsed and all users in the list are assigned to the project.
    IMPORTANT: USERS NOT IN THE LIST ARE REMOVED FROM THE PROJECT, therefore this method can be used
    for both actions.
     * @param projectId The id of the project to assign the user to
     * @param userIds The id of the user to assign
     * @return A DefaultRequestResult object with the result of the operation
     */
    assignUsers(projectId: number, userIds: string): Observable<DefaultRequestResult>;
    /**
     * Updates the projects header data
     * @param model The model with the header data to update the project with
     * @return A ProjectHeaderResult object with the updated header data
     */
    updateHeader(model: UpdateProjectHeaderModel): Observable<ProjectHeaderResult>;
    /**
     * Updates the state of a project
     * @param model The model for the state change
     * @return A DefaultRequestResult object with the result of the operation
     */
    updateState(model: UpdateStateModel): Observable<DefaultRequestResult>;
    /**
     * Requests a project to be started
     * @param model The model for the request
     * @return A DefaultRequestResultobject with the result of the operation
     */
    requestProject(model: ProjectRequestModel): Observable<DefaultRequestResult>;
    /**
     * Updates the state of a project
     * @param model The model for the approval
     * @return A DefaultRequestResult object with the result of the operation
     */
    approve(model: ProjectRequestModel): Observable<DefaultRequestResult>;
    /**
     * Updates the state of a project
     * @param model The model for the request
     * @return A DefaultRequestResult object with the result of the operation
     */
    reject(model: ProjectRequestModel): Observable<DefaultRequestResult>;
    /**
     * Sends an email to the Purchasing Department.
     * @param projectId The id of the project to assign the user to
     * @return A DefaultRequestResult object with the result of the operation
     */
    sendPurchaseDepartmentMail(projectId: number): Observable<DefaultRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectsClient implements IProjectsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns the list of projects from the database
     * @return A ProjectListResult object containing the list of project states
     */
    getList(): Observable<ProjectListResult> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectListResult>;
        }));
    }

    protected processGetList(response: HttpResponseBase): Observable<ProjectListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inserts a single project into the database
     * @param model The model of the project to insert into the database
     * @return A ProjectResult object with the data of the inserted project
     */
    insert(model: InsertProjectModel): Observable<ProjectResult> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsert(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsert(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectResult>;
        }));
    }

    protected processInsert(response: HttpResponseBase): Observable<ProjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 201) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result201: any = null;
            let resultData201 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result201 = ProjectResult.fromJS(resultData201);
            return _observableOf(result201);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates a project in the database
     * @param model The model with the data to update the project with
     * @return A ProjectResult object with the data of the updated project
     */
    update(model: UpdateProjectModel): Observable<ProjectResult> {
        let url_ = this.baseUrl + "/api/Projects";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdate(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdate(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectResult>;
        }));
    }

    protected processUpdate(response: HttpResponseBase): Observable<ProjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the project overview from the database. The overview contains a list of projects and the statistic
    data (active project count, planned project count, closed project count, for the current year)
    Since a body can not be provided for get methods, this method is provided as post.
     * @return A ProjectOverviewResult object containing the overview of projects
     */
    getOverviewPOST(model: ProjectFilterModel): Observable<ProjectOverviewResult> {
        let url_ = this.baseUrl + "/api/Projects/overview";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverviewPOST(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverviewPOST(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectOverviewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectOverviewResult>;
        }));
    }

    protected processGetOverviewPOST(response: HttpResponseBase): Observable<ProjectOverviewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectOverviewResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the project overview from the database. The overview contains a list of projects and the statistic
    data (active project count, planned project count, closed project count, for the current year)
     * @return A ProjectOverviewResult object containing the overview of projects
     */
    getOverviewGET(): Observable<ProjectOverviewResult> {
        let url_ = this.baseUrl + "/api/Projects/overview";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetOverviewGET(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetOverviewGET(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectOverviewResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectOverviewResult>;
        }));
    }

    protected processGetOverviewGET(response: HttpResponseBase): Observable<ProjectOverviewResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectOverviewResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a single project from the database (e.g. for editing or displaying)
     * @param id The id of the project to retrieve from the database
     * @return A ProjectResult object containing the requested project
     */
    get(id: number): Observable<ProjectResult> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes a project from the database
     * @param id The id of the project to delete
     * @return A DefaultRequestResult object with the result of the operation
     */
    delete(id: number): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/{id}";
        if (id === undefined || id === null)
            throw new globalThis.Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDelete(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDelete(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processDelete(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status === 400) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result400: any = null;
            let resultData400 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result400 = ProblemDetails.fromJS(resultData400);
            return throwException("A server side error occurred.", status, _responseText, _headers, result400);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Assigns users to a project. The user ids need to be provided as a comma separated string and must be
    of type int. The ids are parsed and all users in the list are assigned to the project.
    IMPORTANT: USERS NOT IN THE LIST ARE REMOVED FROM THE PROJECT, therefore this method can be used
    for both actions.
     * @param projectId The id of the project to assign the user to
     * @param userIds The id of the user to assign
     * @return A DefaultRequestResult object with the result of the operation
     */
    assignUsers(projectId: number, userIds: string): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/assign/{projectId}/{userIds}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        if (userIds === undefined || userIds === null)
            throw new globalThis.Error("The parameter 'userIds' must be defined.");
        url_ = url_.replace("{userIds}", encodeURIComponent("" + userIds));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processAssignUsers(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processAssignUsers(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processAssignUsers(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the projects header data
     * @param model The model with the header data to update the project with
     * @return A ProjectHeaderResult object with the updated header data
     */
    updateHeader(model: UpdateProjectHeaderModel): Observable<ProjectHeaderResult> {
        let url_ = this.baseUrl + "/api/Projects/updateheader";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateHeader(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateHeader(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectHeaderResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectHeaderResult>;
        }));
    }

    protected processUpdateHeader(response: HttpResponseBase): Observable<ProjectHeaderResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectHeaderResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the state of a project
     * @param model The model for the state change
     * @return A DefaultRequestResult object with the result of the operation
     */
    updateState(model: UpdateStateModel): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/updatestate";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateState(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateState(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processUpdateState(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Requests a project to be started
     * @param model The model for the request
     * @return A DefaultRequestResultobject with the result of the operation
     */
    requestProject(model: ProjectRequestModel): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/requestproject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processRequestProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processRequestProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processRequestProject(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the state of a project
     * @param model The model for the approval
     * @return A DefaultRequestResult object with the result of the operation
     */
    approve(model: ProjectRequestModel): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/approve";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processApprove(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processApprove(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processApprove(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates the state of a project
     * @param model The model for the request
     * @return A DefaultRequestResult object with the result of the operation
     */
    reject(model: ProjectRequestModel): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/reject";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(model);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processReject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processReject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processReject(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Sends an email to the Purchasing Department.
     * @param projectId The id of the project to assign the user to
     * @return A DefaultRequestResult object with the result of the operation
     */
    sendPurchaseDepartmentMail(projectId: number): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Projects/sendpurchasedepartmentmail/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSendPurchaseDepartmentMail(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSendPurchaseDepartmentMail(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processSendPurchaseDepartmentMail(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectStatesClient {
    /**
     * Returns all project types from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A ProjectStateListResult object containing the list of project states
     */
    get(includeInactive: boolean): Observable<ProjectStateListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectStatesClient implements IProjectStatesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all project types from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A ProjectStateListResult object containing the list of project states
     */
    get(includeInactive: boolean): Observable<ProjectStateListResult> {
        let url_ = this.baseUrl + "/api/ProjectStates/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectStateListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectStateListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectStateListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectStateListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IProjectTypesClient {
    /**
     * Returns all project types from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A ProjectTypeListResult object containing the list of project types
     */
    get(includeInactive: boolean): Observable<ProjectTypeListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class ProjectTypesClient implements IProjectTypesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all project types from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A ProjectTypeListResult object containing the list of project types
     */
    get(includeInactive: boolean): Observable<ProjectTypeListResult> {
        let url_ = this.baseUrl + "/api/ProjectTypes/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<ProjectTypeListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<ProjectTypeListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<ProjectTypeListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = ProjectTypeListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IPublicFundingsClient {
    /**
     * Returns all public fundings from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A PublicFundingListResult object containing the list of public fundings
     */
    get(includeInactive: boolean): Observable<PublicFundingListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class PublicFundingsClient implements IPublicFundingsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all public fundings from the database
     * @param includeInactive true if the resulting list should include inactive items, false if not
     * @return A PublicFundingListResult object containing the list of public fundings
     */
    get(includeInactive: boolean): Observable<PublicFundingListResult> {
        let url_ = this.baseUrl + "/api/PublicFundings/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<PublicFundingListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<PublicFundingListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<PublicFundingListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = PublicFundingListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IReportClient {
    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    get(projectId: number): Observable<FileResponse>;
    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    getAll(): Observable<FileResponse>;
    /**
     * Returns a CSV export-file with all projects
     * @return CSV file containing the list of projects
     */
    getAllInCSV(): Observable<FileResponse>;
    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    getMine(): Observable<FileResponse>;
    /**
     * Returns the blacklist report with all projects that have to little documentation
     * @return A PDF file containing the list of respective projects
     */
    getBlacklist(): Observable<FileResponse>;
    /**
     * Returns the management blacklist report with all not-closed projects that have to little documentation
     * @return A PDF file containing the list of respective projects
     */
    getManagementBlacklist(): Observable<FileResponse>;
}

@Injectable({
    providedIn: 'root'
})
export class ReportClient implements IReportClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    get(projectId: number): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    getAll(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/all";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAll(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAll(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAll(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a CSV export-file with all projects
     * @return CSV file containing the list of projects
     */
    getAllInCSV(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/allInCSV";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetAllInCSV(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetAllInCSV(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetAllInCSV(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns a report with all projects
     * @return A PDF file containing the list of projects
     */
    getMine(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/mine";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetMine(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetMine(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetMine(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the blacklist report with all projects that have to little documentation
     * @return A PDF file containing the list of respective projects
     */
    getBlacklist(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/blacklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetBlacklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetBlacklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetBlacklist(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns the management blacklist report with all not-closed projects that have to little documentation
     * @return A PDF file containing the list of respective projects
     */
    getManagementBlacklist(): Observable<FileResponse> {
        let url_ = this.baseUrl + "/api/Report/managementblacklist";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetManagementBlacklist(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetManagementBlacklist(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<FileResponse>;
                }
            } else
                return _observableThrow(response_) as any as Observable<FileResponse>;
        }));
    }

    protected processGetManagementBlacklist(response: HttpResponseBase): Observable<FileResponse> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200 || status === 206) {
            const contentDisposition = response.headers ? response.headers.get("content-disposition") : undefined;
            let fileNameMatch = contentDisposition ? /filename\*=(?:(\\?['"])(.*?)\1|(?:[^\s]+'.*?')?([^;\n]*))/g.exec(contentDisposition) : undefined;
            let fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[3] || fileNameMatch[2] : undefined;
            if (fileName) {
                fileName = decodeURIComponent(fileName);
            } else {
                fileNameMatch = contentDisposition ? /filename="?([^"]*?)"?(;|$)/g.exec(contentDisposition) : undefined;
                fileName = fileNameMatch && fileNameMatch.length > 1 ? fileNameMatch[1] : undefined;
            }
            return _observableOf({ fileName: fileName, data: responseBlob as any, status: status, headers: _headers });
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IRisksClient {
    /**
     * Returns all risk ratings from the database
     * @return A RiskRatingListResult object containing the list of RiskRating items
     */
    getRatings(): Observable<RiskRatingListResult>;
    /**
     * Returns all risks from the database
     * @return A RiskListResult object containing the list of Risk items
     */
    get(projectId: number): Observable<RiskListResult>;
    /**
     * Inserts Risk entries into the database
     * @param models The Risk entries to add to the database
     * @return A RiskListResult object containing the added Risk entries
     */
    insertList(models: InsertRiskModel[]): Observable<RiskListResult>;
    /**
     * Updates multiple Risk entries in the database
     * @param models The Risk entries to update in the database
     * @return A RiskListResult object containing the updated Risk entries
     */
    updateList(models: UpdateRiskModel[]): Observable<RiskListResult>;
    /**
     * Deletes the risks with the provided ids from the database
     * @param riskIds The ids of the risks to delete as a list/an array of int
     * @return A DefaultRequestResult object with the result of the operation
     */
    deleteList(riskIds: number[]): Observable<DefaultRequestResult>;
}

@Injectable({
    providedIn: 'root'
})
export class RisksClient implements IRisksClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all risk ratings from the database
     * @return A RiskRatingListResult object containing the list of RiskRating items
     */
    getRatings(): Observable<RiskRatingListResult> {
        let url_ = this.baseUrl + "/api/Risks/ratings";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetRatings(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetRatings(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskRatingListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskRatingListResult>;
        }));
    }

    protected processGetRatings(response: HttpResponseBase): Observable<RiskRatingListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskRatingListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all risks from the database
     * @return A RiskListResult object containing the list of Risk items
     */
    get(projectId: number): Observable<RiskListResult> {
        let url_ = this.baseUrl + "/api/Risks/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<RiskListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Inserts Risk entries into the database
     * @param models The Risk entries to add to the database
     * @return A RiskListResult object containing the added Risk entries
     */
    insertList(models: InsertRiskModel[]): Observable<RiskListResult> {
        let url_ = this.baseUrl + "/api/Risks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("post", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processInsertList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processInsertList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskListResult>;
        }));
    }

    protected processInsertList(response: HttpResponseBase): Observable<RiskListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Updates multiple Risk entries in the database
     * @param models The Risk entries to update in the database
     * @return A RiskListResult object containing the updated Risk entries
     */
    updateList(models: UpdateRiskModel[]): Observable<RiskListResult> {
        let url_ = this.baseUrl + "/api/Risks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(models);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("put", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processUpdateList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processUpdateList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<RiskListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<RiskListResult>;
        }));
    }

    protected processUpdateList(response: HttpResponseBase): Observable<RiskListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = RiskListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Deletes the risks with the provided ids from the database
     * @param riskIds The ids of the risks to delete as a list/an array of int
     * @return A DefaultRequestResult object with the result of the operation
     */
    deleteList(riskIds: number[]): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Risks";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(riskIds);

        let options_ : any = {
            body: content_,
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Content-Type": "application/json",
                "Accept": "application/json"
            })
        };

        return this.http.request("delete", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processDeleteList(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processDeleteList(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processDeleteList(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITagsClient {
    /**
     * Returns all tags from the database, ordered by name
     * @return A PublicFundingListResult object containing the list of tags
     */
    get(): Observable<TagListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class TagsClient implements ITagsClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Returns all tags from the database, ordered by name
     * @return A PublicFundingListResult object containing the list of tags
     */
    get(): Observable<TagListResult> {
        let url_ = this.baseUrl + "/api/Tags";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TagListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TagListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TagListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TagListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface ITransferSuccessesClient {
    /**
     * Read transfer success status-information
     * @param includeInactive If true, include deactivated items
     */
    get(includeInactive: boolean): Observable<TransferSuccessListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class TransferSuccessesClient implements ITransferSuccessesClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Read transfer success status-information
     * @param includeInactive If true, include deactivated items
     */
    get(includeInactive: boolean): Observable<TransferSuccessListResult> {
        let url_ = this.baseUrl + "/api/TransferSuccesses/{includeInactive}";
        if (includeInactive === undefined || includeInactive === null)
            throw new globalThis.Error("The parameter 'includeInactive' must be defined.");
        url_ = url_.replace("{includeInactive}", encodeURIComponent("" + includeInactive));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<TransferSuccessListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<TransferSuccessListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<TransferSuccessListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = TransferSuccessListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

export interface IUsersClient {
    /**
     * Synchronize user information from AAD groups into the FDB-database
     */
    synchronize(): Observable<DefaultRequestResult>;
    /**
     * Returns all users from the database, ordered by name
     * @return A PublicFundingListResult object containing the list of tags
     */
    get(): Observable<UserListResult>;
    /**
     * Returns all users from the database that belong to the role(s) provided. The role can be either
    an id of a role, the name of a role, multiple ids of a role (comma-separated) or multiple role names
    (also comma-separated). The system decides based on the type, meaning if the value provided is an
    Int32, it's used as an id, if it is a String
    it's used as a name. You should not mix the different types.
     * @return A PublicFundingListResult object containing the list of tags
     */
    get2(roles: string): Observable<UserListResult>;
    /**
     * Get users for a given project
     */
    getForProject(projectId: number): Observable<UserListResult>;
    /**
     * Get current user
     */
    getCurrentUser(): Observable<UserResult>;
    /**
     * Get roles of current user
     */
    getCurrentUserRoles(): Observable<string[]>;
    /**
     * Get list of project managers
     */
    getProjectLeads(): Observable<UserListResult>;
}

@Injectable({
    providedIn: 'root'
})
export class UsersClient implements IUsersClient {
    private http: HttpClient;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(@Inject(HttpClient) http: HttpClient, @Optional() @Inject(API_BASE_URL) baseUrl?: string) {
        this.http = http;
        this.baseUrl = baseUrl ?? "";
    }

    /**
     * Synchronize user information from AAD groups into the FDB-database
     */
    synchronize(): Observable<DefaultRequestResult> {
        let url_ = this.baseUrl + "/api/Users/Synchronize";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processSynchronize(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processSynchronize(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<DefaultRequestResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<DefaultRequestResult>;
        }));
    }

    protected processSynchronize(response: HttpResponseBase): Observable<DefaultRequestResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = DefaultRequestResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all users from the database, ordered by name
     * @return A PublicFundingListResult object containing the list of tags
     */
    get(): Observable<UserListResult> {
        let url_ = this.baseUrl + "/api/Users";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResult>;
        }));
    }

    protected processGet(response: HttpResponseBase): Observable<UserListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Returns all users from the database that belong to the role(s) provided. The role can be either
    an id of a role, the name of a role, multiple ids of a role (comma-separated) or multiple role names
    (also comma-separated). The system decides based on the type, meaning if the value provided is an
    Int32, it's used as an id, if it is a String
    it's used as a name. You should not mix the different types.
     * @return A PublicFundingListResult object containing the list of tags
     */
    get2(roles: string): Observable<UserListResult> {
        let url_ = this.baseUrl + "/api/Users/{roles}";
        if (roles === undefined || roles === null)
            throw new globalThis.Error("The parameter 'roles' must be defined.");
        url_ = url_.replace("{roles}", encodeURIComponent("" + roles));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGet2(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGet2(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResult>;
        }));
    }

    protected processGet2(response: HttpResponseBase): Observable<UserListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get users for a given project
     */
    getForProject(projectId: number): Observable<UserListResult> {
        let url_ = this.baseUrl + "/api/Users/project/{projectId}";
        if (projectId === undefined || projectId === null)
            throw new globalThis.Error("The parameter 'projectId' must be defined.");
        url_ = url_.replace("{projectId}", encodeURIComponent("" + projectId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetForProject(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetForProject(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResult>;
        }));
    }

    protected processGetForProject(response: HttpResponseBase): Observable<UserListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get current user
     */
    getCurrentUser(): Observable<UserResult> {
        let url_ = this.baseUrl + "/api/Users/currentUser";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUser(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUser(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserResult>;
        }));
    }

    protected processGetCurrentUser(response: HttpResponseBase): Observable<UserResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get roles of current user
     */
    getCurrentUserRoles(): Observable<string[]> {
        let url_ = this.baseUrl + "/api/Users/authorizedRoles";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetCurrentUserRoles(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetCurrentUserRoles(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<string[]>;
                }
            } else
                return _observableThrow(response_) as any as Observable<string[]>;
        }));
    }

    protected processGetCurrentUserRoles(response: HttpResponseBase): Observable<string[]> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            if (Array.isArray(resultData200)) {
                result200 = [] as any;
                for (let item of resultData200)
                    result200!.push(item);
            }
            else {
                result200 = null as any;
            }
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }

    /**
     * Get list of project managers
     */
    getProjectLeads(): Observable<UserListResult> {
        let url_ = this.baseUrl + "/api/Users/leads";
        url_ = url_.replace(/[?&]$/, "");

        let options_ : any = {
            observe: "response",
            responseType: "blob",
            headers: new HttpHeaders({
                "Accept": "application/json"
            })
        };

        return this.http.request("get", url_, options_).pipe(_observableMergeMap((response_ : any) => {
            return this.processGetProjectLeads(response_);
        })).pipe(_observableCatch((response_: any) => {
            if (response_ instanceof HttpResponseBase) {
                try {
                    return this.processGetProjectLeads(response_ as any);
                } catch (e) {
                    return _observableThrow(e) as any as Observable<UserListResult>;
                }
            } else
                return _observableThrow(response_) as any as Observable<UserListResult>;
        }));
    }

    protected processGetProjectLeads(response: HttpResponseBase): Observable<UserListResult> {
        const status = response.status;
        const responseBlob =
            response instanceof HttpResponse ? response.body :
            (response as any).error instanceof Blob ? (response as any).error : undefined;

        let _headers: any = {}; if (response.headers) { for (let key of response.headers.keys()) { _headers[key] = response.headers.get(key); }}
        if (status === 200) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            let result200: any = null;
            let resultData200 = _responseText === "" ? null : JSON.parse(_responseText, this.jsonParseReviver);
            result200 = UserListResult.fromJS(resultData200);
            return _observableOf(result200);
            }));
        } else if (status !== 200 && status !== 204) {
            return blobToText(responseBlob).pipe(_observableMergeMap((_responseText: string) => {
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
            }));
        }
        return _observableOf(null as any);
    }
}

/** Default Result Data */
export class DefaultRequestResult implements IDefaultRequestResult {
    /** Returns true if the RequestModel contains errors. It's basically the negation of the IsValid property */
    isSuccessful!: boolean;
    /** A message for the recipient. This message is not necessarily available. */
    message?: string | undefined;
    /** The HttpStatus to return (default: 200) */
    statusCode!: number;

    constructor(data?: IDefaultRequestResult) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSuccessful = _data["isSuccessful"];
            this.message = _data["message"];
            this.statusCode = _data["statusCode"];
        }
    }

    static fromJS(data: any): DefaultRequestResult {
        data = typeof data === 'object' ? data : {};
        let result = new DefaultRequestResult();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSuccessful"] = this.isSuccessful;
        data["message"] = this.message;
        data["statusCode"] = this.statusCode;
        return data;
    }
}

/** Default Result Data */
export interface IDefaultRequestResult {
    /** Returns true if the RequestModel contains errors. It's basically the negation of the IsValid property */
    isSuccessful: boolean;
    /** A message for the recipient. This message is not necessarily available. */
    message?: string | undefined;
    /** The HttpStatus to return (default: 200) */
    statusCode: number;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfAcademicPartnerModel extends DefaultRequestResult implements IRequestResultOfListOfAcademicPartnerModel {
    /** The payload (the result of the operation) */
    payload?: AcademicPartnerModel[] | undefined;

    constructor(data?: IRequestResultOfListOfAcademicPartnerModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new AcademicPartnerModel(item) : item as AcademicPartnerModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(AcademicPartnerModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfAcademicPartnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfAcademicPartnerModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfAcademicPartnerModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IAcademicPartnerModel[] | undefined;
}

/** Result Data to return a list of academic partners */
export class AcademicPartnerListResult extends RequestResultOfListOfAcademicPartnerModel implements IAcademicPartnerListResult {

    constructor(data?: IAcademicPartnerListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): AcademicPartnerListResult {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicPartnerListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return a list of academic partners */
export interface IAcademicPartnerListResult extends IRequestResultOfListOfAcademicPartnerModel {
}

/** The model for an academic partner to displayin a list */
export class AcademicPartnerModel implements IAcademicPartnerModel {
    /** The Id of the academic partner */
    id!: number;
    /** The name of the academic partner */
    name?: string | undefined;
    /** true if the academic partner is active, false if not */
    isActive!: boolean;

    constructor(data?: IAcademicPartnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): AcademicPartnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new AcademicPartnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** The model for an academic partner to displayin a list */
export interface IAcademicPartnerModel {
    /** The Id of the academic partner */
    id: number;
    /** The name of the academic partner */
    name?: string | undefined;
    /** true if the academic partner is active, false if not */
    isActive: boolean;
}

export class ProblemDetails implements IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;

    constructor(data?: IProblemDetails) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            for (var property in _data) {
                if (_data.hasOwnProperty(property))
                    this[property] = _data[property];
            }
            this.type = _data["type"];
            this.title = _data["title"];
            this.status = _data["status"];
            this.detail = _data["detail"];
            this.instance = _data["instance"];
        }
    }

    static fromJS(data: any): ProblemDetails {
        data = typeof data === 'object' ? data : {};
        let result = new ProblemDetails();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        for (var property in this) {
            if (this.hasOwnProperty(property))
                data[property] = this[property];
        }
        data["type"] = this.type;
        data["title"] = this.title;
        data["status"] = this.status;
        data["detail"] = this.detail;
        data["instance"] = this.instance;
        return data;
    }
}

export interface IProblemDetails {
    type?: string | undefined;
    title?: string | undefined;
    status?: number | undefined;
    detail?: string | undefined;
    instance?: string | undefined;

    [key: string]: any;
}

/** Model to add new academic partners */
export class InsertAcademicPartnerModel implements IInsertAcademicPartnerModel {
    /** The name of the academic partner */
    name!: string;

    constructor(data?: IInsertAcademicPartnerModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InsertAcademicPartnerModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertAcademicPartnerModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

/** Model to add new academic partners */
export interface IInsertAcademicPartnerModel {
    /** The name of the academic partner */
    name: string;
}

/** The Config Model for the Client with all Information from Backend AppSetting */
export class ClientSettingModel implements IClientSettingModel {
    /** Contains all configuration values for MSAL authentication */
    msal?: MsalOptions | undefined;
    /** Contains the assembly version (Major.Minor.Revision-No) */
    assemblyVersion?: string | undefined;
    /** Environment dev/test/prod */
    stage!: StageName;
    /** Mail redirection (if set) */
    mailRedirect?: string | undefined;
    /** True, if no mails are sent at all */
    ignoreMail!: boolean;
    /** Debugging-Info to be displayed (e.g. dev/test version, mail-redirections, ...) */
    debuggingInfo?: string | undefined;

    constructor(data?: IClientSettingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.msal = data.msal && !(data.msal as any).toJSON ? new MsalOptions(data.msal) : this.msal as MsalOptions;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.msal = _data["msal"] ? MsalOptions.fromJS(_data["msal"]) : undefined as any;
            this.assemblyVersion = _data["assemblyVersion"];
            this.stage = _data["stage"];
            this.mailRedirect = _data["mailRedirect"];
            this.ignoreMail = _data["ignoreMail"];
            this.debuggingInfo = _data["debuggingInfo"];
        }
    }

    static fromJS(data: any): ClientSettingModel {
        data = typeof data === 'object' ? data : {};
        let result = new ClientSettingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["msal"] = this.msal ? this.msal.toJSON() : undefined as any;
        data["assemblyVersion"] = this.assemblyVersion;
        data["stage"] = this.stage;
        data["mailRedirect"] = this.mailRedirect;
        data["ignoreMail"] = this.ignoreMail;
        data["debuggingInfo"] = this.debuggingInfo;
        return data;
    }
}

/** The Config Model for the Client with all Information from Backend AppSetting */
export interface IClientSettingModel {
    /** Contains all configuration values for MSAL authentication */
    msal?: IMsalOptions | undefined;
    /** Contains the assembly version (Major.Minor.Revision-No) */
    assemblyVersion?: string | undefined;
    /** Environment dev/test/prod */
    stage: StageName;
    /** Mail redirection (if set) */
    mailRedirect?: string | undefined;
    /** True, if no mails are sent at all */
    ignoreMail: boolean;
    /** Debugging-Info to be displayed (e.g. dev/test version, mail-redirections, ...) */
    debuggingInfo?: string | undefined;
}

/** Microsoft Authentication Library for Angular */
export class MsalOptions implements IMsalOptions {
    /** The client ID of the app registration that is valid for the client. */
    clientID?: string | undefined;
    /** A URL indicating a directory that MSAL can use to obtain tokens.
- In Azure AD, it is of the form https://{instance}/{tenant}, where {instance} is the directory host (e.g. https://login.microsoftonline.com) and {tenant} is a identifier within the directory itself (e.g. a domain associated to the tenant, such as contoso.onmicrosoft.com, or the GUID representing the TenantID property of the directory)
- In Azure B2C, it is of the form https://{instance}/tfp/{tenantId}/{policyName}/
- Default value is: "https://login.microsoftonline.com/common" */
    authority?: string | undefined;
    /** The redirect URI of your app, where authentication responses can be sent and received by your app. It must exactly match one of the redirect URIs you registered in the portal, except that it must be URL encoded. Defaults to window.location.href. */
    redirectUri?: string | undefined;
    /** Validate the issuer of tokens. Default is true. */
    validateAuthority!: boolean;
    /** Sets browser storage to either localStorage or sessionStorage. Defaults to sessionStorage. */
    cacheLocation?: string | undefined;
    /** Redirects the user to postLogoutRedirectUri after logout. Defaults is 'redirectUri'. */
    postLogoutRedirectUri?: string | undefined;
    /** Ability to turn off default navigation to start page after login. Default is true. This is used only for redirect flows. */
    navigateToLoginRequestUrl!: boolean;
    /** Show login popup or redirect. Default:Redirect */
    popUp!: boolean;
    /** Mapping of resources to scopes {"https://graph.microsoft.com/v1.0/me", ["user.read", "mail.send"]}. Used internally by the MSAL for automatically attaching tokens in webApi calls. This is required only for CORS calls.
             */
    protectedResourceMap?: string | undefined;
    /** PII stands for Personal Identifiable Information. By default, MSAL does not capture or log any PII. By turning on PII,
the app takes responsibility for safely handling highly-sensitive data and complying with any regulatory requirements.
This flag is to enable/disable logging of PII data. PII logs are never written to default outputs like Console, Logcat or NSLog.
Default is set to false. */
    piiLoggingEnabled!: boolean;

    constructor(data?: IMsalOptions) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.clientID = _data["clientID"];
            this.authority = _data["authority"];
            this.redirectUri = _data["redirectUri"];
            this.validateAuthority = _data["validateAuthority"];
            this.cacheLocation = _data["cacheLocation"];
            this.postLogoutRedirectUri = _data["postLogoutRedirectUri"];
            this.navigateToLoginRequestUrl = _data["navigateToLoginRequestUrl"];
            this.popUp = _data["popUp"];
            this.protectedResourceMap = _data["protectedResourceMap"];
            this.piiLoggingEnabled = _data["piiLoggingEnabled"];
        }
    }

    static fromJS(data: any): MsalOptions {
        data = typeof data === 'object' ? data : {};
        let result = new MsalOptions();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["clientID"] = this.clientID;
        data["authority"] = this.authority;
        data["redirectUri"] = this.redirectUri;
        data["validateAuthority"] = this.validateAuthority;
        data["cacheLocation"] = this.cacheLocation;
        data["postLogoutRedirectUri"] = this.postLogoutRedirectUri;
        data["navigateToLoginRequestUrl"] = this.navigateToLoginRequestUrl;
        data["popUp"] = this.popUp;
        data["protectedResourceMap"] = this.protectedResourceMap;
        data["piiLoggingEnabled"] = this.piiLoggingEnabled;
        return data;
    }
}

/** Microsoft Authentication Library for Angular */
export interface IMsalOptions {
    /** The client ID of the app registration that is valid for the client. */
    clientID?: string | undefined;
    /** A URL indicating a directory that MSAL can use to obtain tokens.
- In Azure AD, it is of the form https://{instance}/{tenant}, where {instance} is the directory host (e.g. https://login.microsoftonline.com) and {tenant} is a identifier within the directory itself (e.g. a domain associated to the tenant, such as contoso.onmicrosoft.com, or the GUID representing the TenantID property of the directory)
- In Azure B2C, it is of the form https://{instance}/tfp/{tenantId}/{policyName}/
- Default value is: "https://login.microsoftonline.com/common" */
    authority?: string | undefined;
    /** The redirect URI of your app, where authentication responses can be sent and received by your app. It must exactly match one of the redirect URIs you registered in the portal, except that it must be URL encoded. Defaults to window.location.href. */
    redirectUri?: string | undefined;
    /** Validate the issuer of tokens. Default is true. */
    validateAuthority: boolean;
    /** Sets browser storage to either localStorage or sessionStorage. Defaults to sessionStorage. */
    cacheLocation?: string | undefined;
    /** Redirects the user to postLogoutRedirectUri after logout. Defaults is 'redirectUri'. */
    postLogoutRedirectUri?: string | undefined;
    /** Ability to turn off default navigation to start page after login. Default is true. This is used only for redirect flows. */
    navigateToLoginRequestUrl: boolean;
    /** Show login popup or redirect. Default:Redirect */
    popUp: boolean;
    /** Mapping of resources to scopes {"https://graph.microsoft.com/v1.0/me", ["user.read", "mail.send"]}. Used internally by the MSAL for automatically attaching tokens in webApi calls. This is required only for CORS calls.
             */
    protectedResourceMap?: string | undefined;
    /** PII stands for Personal Identifiable Information. By default, MSAL does not capture or log any PII. By turning on PII,
the app takes responsibility for safely handling highly-sensitive data and complying with any regulatory requirements.
This flag is to enable/disable logging of PII data. PII logs are never written to default outputs like Console, Logcat or NSLog.
Default is set to false. */
    piiLoggingEnabled: boolean;
}

/** Predefined name for stages */
export enum StageName {
    None = 0,
    Dev = 1,
    Test = 2,
    Prod = 3,
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfProjectCostsModel extends DefaultRequestResult implements IRequestResultOfProjectCostsModel {
    /** The payload (the result of the operation) */
    payload?: ProjectCostsModel | undefined;

    constructor(data?: IRequestResultOfProjectCostsModel) {
        super(data);
        if (data) {
            this.payload = data.payload && !(data.payload as any).toJSON ? new ProjectCostsModel(data.payload) : this.payload as ProjectCostsModel;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payload = _data["payload"] ? ProjectCostsModel.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RequestResultOfProjectCostsModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfProjectCostsModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfProjectCostsModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectCostsModel | undefined;
}

/** Result Data to return a list of academic partners */
export class ProjectCostResult extends RequestResultOfProjectCostsModel implements IProjectCostResult {

    constructor(data?: IProjectCostResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectCostResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCostResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return a list of academic partners */
export interface IProjectCostResult extends IRequestResultOfProjectCostsModel {
}

/** the model for all Cost Position to a Project */
export class ProjectCostsModel implements IProjectCostsModel {
    /** Contains all CostAccount to the Project */
    costAccounts?: CostAccountModel[] | undefined;
    /** Contains all Costs to the Project */
    costs?: CostModel[] | undefined;

    constructor(data?: IProjectCostsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.costAccounts) {
                this.costAccounts = [];
                for (let i = 0; i < data.costAccounts.length; i++) {
                    let item = data.costAccounts[i];
                    this.costAccounts[i] = item && !(item as any).toJSON ? new CostAccountModel(item) : item as CostAccountModel;
                }
            }
            if (data.costs) {
                this.costs = [];
                for (let i = 0; i < data.costs.length; i++) {
                    let item = data.costs[i];
                    this.costs[i] = item && !(item as any).toJSON ? new CostModel(item) : item as CostModel;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costAccounts"])) {
                this.costAccounts = [] as any;
                for (let item of _data["costAccounts"])
                    this.costAccounts!.push(CostAccountModel.fromJS(item));
            }
            if (Array.isArray(_data["costs"])) {
                this.costs = [] as any;
                for (let item of _data["costs"])
                    this.costs!.push(CostModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectCostsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectCostsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costAccounts)) {
            data["costAccounts"] = [];
            for (let item of this.costAccounts)
                data["costAccounts"].push(item ? item.toJSON() : undefined as any);
        }
        if (Array.isArray(this.costs)) {
            data["costs"] = [];
            for (let item of this.costs)
                data["costs"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** the model for all Cost Position to a Project */
export interface IProjectCostsModel {
    /** Contains all CostAccount to the Project */
    costAccounts?: ICostAccountModel[] | undefined;
    /** Contains all Costs to the Project */
    costs?: ICostModel[] | undefined;
}

/** the model for a CostAccount */
export class CostAccountModel implements ICostAccountModel {
    /** The Id of Cost Account Item */
    id!: number;
    /** The ProjectId with which the cost account is referenced. */
    projectId!: number;
    /** Contains the year to which the value applies. */
    year!: number;
    /** Contains the PSPElement from CostAccount */
    psp?: string | undefined;

    constructor(data?: ICostAccountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.year = _data["year"];
            this.psp = _data["psp"];
        }
    }

    static fromJS(data: any): CostAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostAccountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["year"] = this.year;
        data["psp"] = this.psp;
        return data;
    }
}

/** the model for a CostAccount */
export interface ICostAccountModel {
    /** The Id of Cost Account Item */
    id: number;
    /** The ProjectId with which the cost account is referenced. */
    projectId: number;
    /** Contains the year to which the value applies. */
    year: number;
    /** Contains the PSPElement from CostAccount */
    psp?: string | undefined;
}

/** The model for a Item from Cost */
export class CostModel implements ICostModel {
    /** The id of the Cost Item */
    id!: number;
    /** The ProjectId with which the cost is referenced. */
    projectId!: number;
    /** The Id from CostTyp where are reference */
    costTypeId!: number;
    /** Displays the day from which the values were determined. */
    date!: moment.Moment;
    /** The Cost Type where are referenced */
    costType?: CostTypeModel | undefined;
    /** The sum of the individual amounts is determined here. */
    sumAmount!: number;
    /** Contains the cost of 4 years from current year ascending */
    costAmounts?: CostAmountModel[] | undefined;

    constructor(data?: ICostModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.costType = data.costType && !(data.costType as any).toJSON ? new CostTypeModel(data.costType) : this.costType as CostTypeModel;
            if (data.costAmounts) {
                this.costAmounts = [];
                for (let i = 0; i < data.costAmounts.length; i++) {
                    let item = data.costAmounts[i];
                    this.costAmounts[i] = item && !(item as any).toJSON ? new CostAmountModel(item) : item as CostAmountModel;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.costTypeId = _data["costTypeId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.costType = _data["costType"] ? CostTypeModel.fromJS(_data["costType"]) : undefined as any;
            this.sumAmount = _data["sumAmount"];
            if (Array.isArray(_data["costAmounts"])) {
                this.costAmounts = [] as any;
                for (let item of _data["costAmounts"])
                    this.costAmounts!.push(CostAmountModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["costTypeId"] = this.costTypeId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["costType"] = this.costType ? this.costType.toJSON() : undefined as any;
        data["sumAmount"] = this.sumAmount;
        if (Array.isArray(this.costAmounts)) {
            data["costAmounts"] = [];
            for (let item of this.costAmounts)
                data["costAmounts"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** The model for a Item from Cost */
export interface ICostModel {
    /** The id of the Cost Item */
    id: number;
    /** The ProjectId with which the cost is referenced. */
    projectId: number;
    /** The Id from CostTyp where are reference */
    costTypeId: number;
    /** Displays the day from which the values were determined. */
    date: moment.Moment;
    /** The Cost Type where are referenced */
    costType?: ICostTypeModel | undefined;
    /** The sum of the individual amounts is determined here. */
    sumAmount: number;
    /** Contains the cost of 4 years from current year ascending */
    costAmounts?: ICostAmountModel[] | undefined;
}

/** the model for the Cost Type */
export class CostTypeModel implements ICostTypeModel {
    /** the id from CostType */
    id!: number;
    /** The Id from CostType */
    type!: InternalCostType;
    /** The name from Cost Type */
    name?: string | undefined;
    /** The Id from Enum CostTypeSource */
    sourceId!: CostTypeSource;
    /** The Id from Enum Cost Types Area */
    areaId!: CostTypeArea;

    constructor(data?: ICostTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.type = _data["type"];
            this.name = _data["name"];
            this.sourceId = _data["sourceId"];
            this.areaId = _data["areaId"];
        }
    }

    static fromJS(data: any): CostTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["type"] = this.type;
        data["name"] = this.name;
        data["sourceId"] = this.sourceId;
        data["areaId"] = this.areaId;
        return data;
    }
}

/** the model for the Cost Type */
export interface ICostTypeModel {
    /** the id from CostType */
    id: number;
    /** The Id from CostType */
    type: InternalCostType;
    /** The name from Cost Type */
    name?: string | undefined;
    /** The Id from Enum CostTypeSource */
    sourceId: CostTypeSource;
    /** The Id from Enum Cost Types Area */
    areaId: CostTypeArea;
}

/** various types for internal costs */
export enum InternalCostType {
    None = 0,
    CostPlanningData = 1,
    BudgetUtilized = 2,
    OpenOrderValue = 3,
    PlannedSponsoring = 4,
    ReceivedSponsoring = 5,
}

/** The enum describes the source of the cost type. */
export enum CostTypeSource {
    EnBW = 0,
    SAP = 1,
}

/** Lists all possible areas */
export enum CostTypeArea {
    EditValue = 0,
    Costs = 1,
    PublicSponsoring = 2,
}

/** The model for a CostAmount */
export class CostAmountModel implements ICostAmountModel {
    /** The id of the Cost Amount */
    id!: number;
    /** the id of the referenced Cost */
    costId!: number;
    /** Contains the year to which the value applies. */
    year!: number;
    /** Contains the Value from Amount */
    amount!: number;

    constructor(data?: ICostAmountModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costId = _data["costId"];
            this.year = _data["year"];
            this.amount = _data["amount"];
        }
    }

    static fromJS(data: any): CostAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new CostAmountModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costId"] = this.costId;
        data["year"] = this.year;
        data["amount"] = this.amount;
        return data;
    }
}

/** The model for a CostAmount */
export interface ICostAmountModel {
    /** The id of the Cost Amount */
    id: number;
    /** the id of the referenced Cost */
    costId: number;
    /** Contains the year to which the value applies. */
    year: number;
    /** Contains the Value from Amount */
    amount: number;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfCostAccountModel extends DefaultRequestResult implements IRequestResultOfListOfCostAccountModel {
    /** The payload (the result of the operation) */
    payload?: CostAccountModel[] | undefined;

    constructor(data?: IRequestResultOfListOfCostAccountModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new CostAccountModel(item) : item as CostAccountModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(CostAccountModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfCostAccountModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfCostAccountModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfCostAccountModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: ICostAccountModel[] | undefined;
}

/** The result object for the Cost request */
export class CostAccountListResult extends RequestResultOfListOfCostAccountModel implements ICostAccountListResult {

    constructor(data?: ICostAccountListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CostAccountListResult {
        data = typeof data === 'object' ? data : {};
        let result = new CostAccountListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for the Cost request */
export interface ICostAccountListResult extends IRequestResultOfListOfCostAccountModel {
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfCostAmountModel extends DefaultRequestResult implements IRequestResultOfListOfCostAmountModel {
    /** The payload (the result of the operation) */
    payload?: CostAmountModel[] | undefined;

    constructor(data?: IRequestResultOfListOfCostAmountModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new CostAmountModel(item) : item as CostAmountModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(CostAmountModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfCostAmountModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfCostAmountModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfCostAmountModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: ICostAmountModel[] | undefined;
}

/** The result object for the Cost Amount */
export class CostAmountListResult extends RequestResultOfListOfCostAmountModel implements ICostAmountListResult {

    constructor(data?: ICostAmountListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): CostAmountListResult {
        data = typeof data === 'object' ? data : {};
        let result = new CostAmountListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for the Cost Amount */
export interface ICostAmountListResult extends IRequestResultOfListOfCostAmountModel {
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfEnBWUnitModel extends DefaultRequestResult implements IRequestResultOfListOfEnBWUnitModel {
    /** The payload (the result of the operation) */
    payload?: EnBWUnitModel[] | undefined;

    constructor(data?: IRequestResultOfListOfEnBWUnitModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new EnBWUnitModel(item) : item as EnBWUnitModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(EnBWUnitModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfEnBWUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfEnBWUnitModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfEnBWUnitModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IEnBWUnitModel[] | undefined;
}

/** The result object for a list of EnBWUnits */
export class EnBWUnitListResult extends RequestResultOfListOfEnBWUnitModel implements IEnBWUnitListResult {

    constructor(data?: IEnBWUnitListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): EnBWUnitListResult {
        data = typeof data === 'object' ? data : {};
        let result = new EnBWUnitListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for a list of EnBWUnits */
export interface IEnBWUnitListResult extends IRequestResultOfListOfEnBWUnitModel {
}

/** The model for the EnBWUnit */
export class EnBWUnitModel implements IEnBWUnitModel {
    /** The id of the EnBWUnit */
    id!: number;
    /** The name of the EnBWUnit */
    name?: string | undefined;
    /** true if the item is active, false if not */
    isActive!: boolean;

    constructor(data?: IEnBWUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): EnBWUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new EnBWUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** The model for the EnBWUnit */
export interface IEnBWUnitModel {
    /** The id of the EnBWUnit */
    id: number;
    /** The name of the EnBWUnit */
    name?: string | undefined;
    /** true if the item is active, false if not */
    isActive: boolean;
}

/** The model to add an EnBWUnit */
export class InsertEnBWUnitModel implements IInsertEnBWUnitModel {
    /** The name of the EnBWUnit */
    name?: string | undefined;

    constructor(data?: IInsertEnBWUnitModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): InsertEnBWUnitModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertEnBWUnitModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        return data;
    }
}

/** The model to add an EnBWUnit */
export interface IInsertEnBWUnitModel {
    /** The name of the EnBWUnit */
    name?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfHelpToolTipModel extends DefaultRequestResult implements IRequestResultOfListOfHelpToolTipModel {
    /** The payload (the result of the operation) */
    payload?: HelpToolTipModel[] | undefined;

    constructor(data?: IRequestResultOfListOfHelpToolTipModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new HelpToolTipModel(item) : item as HelpToolTipModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(HelpToolTipModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfHelpToolTipModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfHelpToolTipModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfHelpToolTipModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IHelpToolTipModel[] | undefined;
}

/** Result Data to return a list of help tooltips */
export class HelpToolTipListResult extends RequestResultOfListOfHelpToolTipModel implements IHelpToolTipListResult {

    constructor(data?: IHelpToolTipListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): HelpToolTipListResult {
        data = typeof data === 'object' ? data : {};
        let result = new HelpToolTipListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return a list of help tooltips */
export interface IHelpToolTipListResult extends IRequestResultOfListOfHelpToolTipModel {
}

/** The model for the HelpToolTip */
export class HelpToolTipModel implements IHelpToolTipModel {
    /** ID / Primary Key */
    id!: number;
    /** The Angular Component in which the field to be documented is located */
    angularComponent?: string | undefined;
    /** Field to be documented */
    fieldId?: string | undefined;
    /** Tool tip for the field */
    toolTip?: string | undefined;

    constructor(data?: IHelpToolTipModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.angularComponent = _data["angularComponent"];
            this.fieldId = _data["fieldId"];
            this.toolTip = _data["toolTip"];
        }
    }

    static fromJS(data: any): HelpToolTipModel {
        data = typeof data === 'object' ? data : {};
        let result = new HelpToolTipModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["angularComponent"] = this.angularComponent;
        data["fieldId"] = this.fieldId;
        data["toolTip"] = this.toolTip;
        return data;
    }
}

/** The model for the HelpToolTip */
export interface IHelpToolTipModel {
    /** ID / Primary Key */
    id: number;
    /** The Angular Component in which the field to be documented is located */
    angularComponent?: string | undefined;
    /** Field to be documented */
    fieldId?: string | undefined;
    /** Tool tip for the field */
    toolTip?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfLogbookModel extends DefaultRequestResult implements IRequestResultOfListOfLogbookModel {
    /** The payload (the result of the operation) */
    payload?: LogbookModel[] | undefined;

    constructor(data?: IRequestResultOfListOfLogbookModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new LogbookModel(item) : item as LogbookModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(LogbookModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfLogbookModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfLogbookModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfLogbookModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: ILogbookModel[] | undefined;
}

/** Result Data to return a list of logbook entries */
export class LogbookListResult extends RequestResultOfListOfLogbookModel implements ILogbookListResult {

    constructor(data?: ILogbookListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): LogbookListResult {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return a list of logbook entries */
export interface ILogbookListResult extends IRequestResultOfListOfLogbookModel {
}

/** Model for logbook entries */
export class LogbookModel implements ILogbookModel {
    /** The id of the logbook entry */
    id!: number;
    /** The id of the project the logbook entry belongs to */
    projectId!: number;
    /** The id of the user the logbook-entry belongs to. */
    userId!: number;
    /** The date of the entry */
    date!: moment.Moment;
    /** The text of the entry */
    info?: string | undefined;
    /** The user who added the logbook-entry */
    user?: UserModel | undefined;

    constructor(data?: ILogbookModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.user = data.user && !(data.user as any).toJSON ? new UserModel(data.user) : this.user as UserModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.userId = _data["userId"];
            this.date = _data["date"] ? moment(_data["date"].toString()) : undefined as any;
            this.info = _data["info"];
            this.user = _data["user"] ? UserModel.fromJS(_data["user"]) : undefined as any;
        }
    }

    static fromJS(data: any): LogbookModel {
        data = typeof data === 'object' ? data : {};
        let result = new LogbookModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["userId"] = this.userId;
        data["date"] = this.date ? this.date.toISOString() : undefined as any;
        data["info"] = this.info;
        data["user"] = this.user ? this.user.toJSON() : undefined as any;
        return data;
    }
}

/** Model for logbook entries */
export interface ILogbookModel {
    /** The id of the logbook entry */
    id: number;
    /** The id of the project the logbook entry belongs to */
    projectId: number;
    /** The id of the user the logbook-entry belongs to. */
    userId: number;
    /** The date of the entry */
    date: moment.Moment;
    /** The text of the entry */
    info?: string | undefined;
    /** The user who added the logbook-entry */
    user?: IUserModel | undefined;
}

/** The model class for a user */
export class UserModel implements IUserModel {
    /** The id of the user */
    id!: number;
    /** The email of the user */
    email?: string | undefined;
    /** The image url of the user */
    imageUrl?: string | undefined;
    /** The first name of the user */
    firstName?: string | undefined;
    /** The last name of the user */
    lastName?: string | undefined;
    /** The active directory id of the user */
    objectId?: string | undefined;
    /** The phone number of the user */
    phone?: string | undefined;
    /** The Fax number of the user */
    fax?: string | undefined;
    /** The roles for the user */
    roles?: RoleModel[] | undefined;

    constructor(data?: IUserModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.roles) {
                this.roles = [];
                for (let i = 0; i < data.roles.length; i++) {
                    let item = data.roles[i];
                    this.roles[i] = item && !(item as any).toJSON ? new RoleModel(item) : item as RoleModel;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.email = _data["email"];
            this.imageUrl = _data["imageUrl"];
            this.firstName = _data["firstName"];
            this.lastName = _data["lastName"];
            this.objectId = _data["objectId"];
            this.phone = _data["phone"];
            this.fax = _data["fax"];
            if (Array.isArray(_data["roles"])) {
                this.roles = [] as any;
                for (let item of _data["roles"])
                    this.roles!.push(RoleModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): UserModel {
        data = typeof data === 'object' ? data : {};
        let result = new UserModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["email"] = this.email;
        data["imageUrl"] = this.imageUrl;
        data["firstName"] = this.firstName;
        data["lastName"] = this.lastName;
        data["objectId"] = this.objectId;
        data["phone"] = this.phone;
        data["fax"] = this.fax;
        if (Array.isArray(this.roles)) {
            data["roles"] = [];
            for (let item of this.roles)
                data["roles"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** The model class for a user */
export interface IUserModel {
    /** The id of the user */
    id: number;
    /** The email of the user */
    email?: string | undefined;
    /** The image url of the user */
    imageUrl?: string | undefined;
    /** The first name of the user */
    firstName?: string | undefined;
    /** The last name of the user */
    lastName?: string | undefined;
    /** The active directory id of the user */
    objectId?: string | undefined;
    /** The phone number of the user */
    phone?: string | undefined;
    /** The Fax number of the user */
    fax?: string | undefined;
    /** The roles for the user */
    roles?: IRoleModel[] | undefined;
}

/** The model for the role of a user */
export class RoleModel implements IRoleModel {
    /** The id of the role */
    id!: number;
    /** The name of the role */
    name?: string | undefined;

    constructor(data?: IRoleModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RoleModel {
        data = typeof data === 'object' ? data : {};
        let result = new RoleModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** The model for the role of a user */
export interface IRoleModel {
    /** The id of the role */
    id: number;
    /** The name of the role */
    name?: string | undefined;
}

/** Model to insert logbook entries */
export class InsertLogbookModel implements IInsertLogbookModel {
    /** The id of the project the logbook entry belongs to */
    projectId!: number;
    /** The text of the entry */
    info?: string | undefined;

    constructor(data?: IInsertLogbookModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): InsertLogbookModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertLogbookModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["info"] = this.info;
        return data;
    }
}

/** Model to insert logbook entries */
export interface IInsertLogbookModel {
    /** The id of the project the logbook entry belongs to */
    projectId: number;
    /** The text of the entry */
    info?: string | undefined;
}

/** Model to update logbook entries */
export class UpdateLogbookModel implements IUpdateLogbookModel {
    /** The id of the logbook entry */
    id!: number;
    /** The text of the entry */
    info?: string | undefined;

    constructor(data?: IUpdateLogbookModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.info = _data["info"];
        }
    }

    static fromJS(data: any): UpdateLogbookModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateLogbookModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["info"] = this.info;
        return data;
    }
}

/** Model to update logbook entries */
export interface IUpdateLogbookModel {
    /** The id of the logbook entry */
    id: number;
    /** The text of the entry */
    info?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfMilestoneModel extends DefaultRequestResult implements IRequestResultOfListOfMilestoneModel {
    /** The payload (the result of the operation) */
    payload?: MilestoneModel[] | undefined;

    constructor(data?: IRequestResultOfListOfMilestoneModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new MilestoneModel(item) : item as MilestoneModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(MilestoneModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfMilestoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfMilestoneModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfMilestoneModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IMilestoneModel[] | undefined;
}

/** The result object for a list of milestones */
export class MilestoneListResult extends RequestResultOfListOfMilestoneModel implements IMilestoneListResult {

    constructor(data?: IMilestoneListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): MilestoneListResult {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for a list of milestones */
export interface IMilestoneListResult extends IRequestResultOfListOfMilestoneModel {
}

/** Model for milestone entries */
export class MilestoneModel implements IMilestoneModel {
    /** The id of the milestone */
    id!: number;
    /** The name of the milestone */
    name?: string | undefined;
    /** The planned date of the milestone */
    plannedDate?: moment.Moment | undefined;
    /** The actual date of the milestone */
    actualDate?: moment.Moment | undefined;
    /** The id of the project the milestone belongs to */
    projectId!: number;
    /** The progress in percent for the milestone */
    progressInPercent!: number;

    constructor(data?: IMilestoneModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.plannedDate = _data["plannedDate"] ? moment(_data["plannedDate"].toString()) : undefined as any;
            this.actualDate = _data["actualDate"] ? moment(_data["actualDate"].toString()) : undefined as any;
            this.projectId = _data["projectId"];
            this.progressInPercent = _data["progressInPercent"];
        }
    }

    static fromJS(data: any): MilestoneModel {
        data = typeof data === 'object' ? data : {};
        let result = new MilestoneModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["plannedDate"] = this.plannedDate ? this.plannedDate.toISOString() : undefined as any;
        data["actualDate"] = this.actualDate ? this.actualDate.toISOString() : undefined as any;
        data["projectId"] = this.projectId;
        data["progressInPercent"] = this.progressInPercent;
        return data;
    }
}

/** Model for milestone entries */
export interface IMilestoneModel {
    /** The id of the milestone */
    id: number;
    /** The name of the milestone */
    name?: string | undefined;
    /** The planned date of the milestone */
    plannedDate?: moment.Moment | undefined;
    /** The actual date of the milestone */
    actualDate?: moment.Moment | undefined;
    /** The id of the project the milestone belongs to */
    projectId: number;
    /** The progress in percent for the milestone */
    progressInPercent: number;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfProjectListItemModel extends DefaultRequestResult implements IRequestResultOfListOfProjectListItemModel {
    /** The payload (the result of the operation) */
    payload?: ProjectListItemModel[] | undefined;

    constructor(data?: IRequestResultOfListOfProjectListItemModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new ProjectListItemModel(item) : item as ProjectListItemModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(ProjectListItemModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfProjectListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfProjectListItemModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfProjectListItemModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectListItemModel[] | undefined;
}

/** Result Data to return a list of projects */
export class ProjectListResult extends RequestResultOfListOfProjectListItemModel implements IProjectListResult {

    constructor(data?: IProjectListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return a list of projects */
export interface IProjectListResult extends IRequestResultOfListOfProjectListItemModel {
}

/** Model to handle project search results */
export class ProjectListItemModel implements IProjectListItemModel {
    /** The id of the project */
    id!: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** The project number */
    number?: string | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The info of the project (the last Logbook Entry infoText) */
    info?: string | undefined;
    /** The start date of the project (the last Logbook Entry infoDate) */
    infoDate?: moment.Moment | undefined;
    /** The end date of the project */
    endDate?: moment.Moment | undefined;
    /** The EnBWUnit responsible for the project */
    enBWunit?: EnBWUnitModel | undefined;
    /** The project state */
    state?: ProjectStateModel | undefined;
    /** The advisor (Betreuer) */
    advisor?: UserModel | undefined;
    /** Project state / phase */
    stateName?: string | undefined;
    /** Advisor's last name */
    advisorName?: string | undefined;
    /** EnBW Unit of project */
    enBWUnitName?: string | undefined;

    constructor(data?: IProjectListItemModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.enBWunit = data.enBWunit && !(data.enBWunit as any).toJSON ? new EnBWUnitModel(data.enBWunit) : this.enBWunit as EnBWUnitModel;
            this.state = data.state && !(data.state as any).toJSON ? new ProjectStateModel(data.state) : this.state as ProjectStateModel;
            this.advisor = data.advisor && !(data.advisor as any).toJSON ? new UserModel(data.advisor) : this.advisor as UserModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateId = _data["stateId"];
            this.enBWunitId = _data["enBWunitId"];
            this.advisorId = _data["advisorId"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.info = _data["info"];
            this.infoDate = _data["infoDate"] ? moment(_data["infoDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.enBWunit = _data["enBWunit"] ? EnBWUnitModel.fromJS(_data["enBWunit"]) : undefined as any;
            this.state = _data["state"] ? ProjectStateModel.fromJS(_data["state"]) : undefined as any;
            this.advisor = _data["advisor"] ? UserModel.fromJS(_data["advisor"]) : undefined as any;
            this.stateName = _data["stateName"];
            this.advisorName = _data["advisorName"];
            this.enBWUnitName = _data["enBWUnitName"];
        }
    }

    static fromJS(data: any): ProjectListItemModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectListItemModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateId"] = this.stateId;
        data["enBWunitId"] = this.enBWunitId;
        data["advisorId"] = this.advisorId;
        data["number"] = this.number;
        data["name"] = this.name;
        data["info"] = this.info;
        data["infoDate"] = this.infoDate ? this.infoDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["enBWunit"] = this.enBWunit ? this.enBWunit.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["advisor"] = this.advisor ? this.advisor.toJSON() : undefined as any;
        data["stateName"] = this.stateName;
        data["advisorName"] = this.advisorName;
        data["enBWUnitName"] = this.enBWUnitName;
        return data;
    }
}

/** Model to handle project search results */
export interface IProjectListItemModel {
    /** The id of the project */
    id: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** The project number */
    number?: string | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The info of the project (the last Logbook Entry infoText) */
    info?: string | undefined;
    /** The start date of the project (the last Logbook Entry infoDate) */
    infoDate?: moment.Moment | undefined;
    /** The end date of the project */
    endDate?: moment.Moment | undefined;
    /** The EnBWUnit responsible for the project */
    enBWunit?: IEnBWUnitModel | undefined;
    /** The project state */
    state?: IProjectStateModel | undefined;
    /** The advisor (Betreuer) */
    advisor?: IUserModel | undefined;
    /** Project state / phase */
    stateName?: string | undefined;
    /** Advisor's last name */
    advisorName?: string | undefined;
    /** EnBW Unit of project */
    enBWUnitName?: string | undefined;
}

/** The model for the project type */
export class ProjectStateModel implements IProjectStateModel {
    /** The id of the project state */
    id!: number;
    /** The name of the project state */
    name?: string | undefined;
    /** true if the project state is active, false if not */
    isActive!: boolean;

    constructor(data?: IProjectStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProjectStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** The model for the project type */
export interface IProjectStateModel {
    /** The id of the project state */
    id: number;
    /** The name of the project state */
    name?: string | undefined;
    /** true if the project state is active, false if not */
    isActive: boolean;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfProjectOverviewModel extends DefaultRequestResult implements IRequestResultOfProjectOverviewModel {
    /** The payload (the result of the operation) */
    payload?: ProjectOverviewModel | undefined;

    constructor(data?: IRequestResultOfProjectOverviewModel) {
        super(data);
        if (data) {
            this.payload = data.payload && !(data.payload as any).toJSON ? new ProjectOverviewModel(data.payload) : this.payload as ProjectOverviewModel;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payload = _data["payload"] ? ProjectOverviewModel.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RequestResultOfProjectOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfProjectOverviewModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfProjectOverviewModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectOverviewModel | undefined;
}

/** Result Data to return the project overview */
export class ProjectOverviewResult extends RequestResultOfProjectOverviewModel implements IProjectOverviewResult {

    constructor(data?: IProjectOverviewResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectOverviewResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOverviewResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return the project overview */
export interface IProjectOverviewResult extends IRequestResultOfProjectOverviewModel {
}

/** Model to handle the project overview */
export class ProjectOverviewModel implements IProjectOverviewModel {
    /** The statistics for the current year */
    statistics?: ProjectStatisticsModel | undefined;
    /** The list of projects */
    projects?: ProjectListItemModel[] | undefined;

    constructor(data?: IProjectOverviewModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.statistics = data.statistics && !(data.statistics as any).toJSON ? new ProjectStatisticsModel(data.statistics) : this.statistics as ProjectStatisticsModel;
            if (data.projects) {
                this.projects = [];
                for (let i = 0; i < data.projects.length; i++) {
                    let item = data.projects[i];
                    this.projects[i] = item && !(item as any).toJSON ? new ProjectListItemModel(item) : item as ProjectListItemModel;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.statistics = _data["statistics"] ? ProjectStatisticsModel.fromJS(_data["statistics"]) : undefined as any;
            if (Array.isArray(_data["projects"])) {
                this.projects = [] as any;
                for (let item of _data["projects"])
                    this.projects!.push(ProjectListItemModel.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ProjectOverviewModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectOverviewModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statistics"] = this.statistics ? this.statistics.toJSON() : undefined as any;
        if (Array.isArray(this.projects)) {
            data["projects"] = [];
            for (let item of this.projects)
                data["projects"].push(item ? item.toJSON() : undefined as any);
        }
        return data;
    }
}

/** Model to handle the project overview */
export interface IProjectOverviewModel {
    /** The statistics for the current year */
    statistics?: IProjectStatisticsModel | undefined;
    /** The list of projects */
    projects?: IProjectListItemModel[] | undefined;
}

/** Model to handle project statistics */
export class ProjectStatisticsModel implements IProjectStatisticsModel {
    /** The year for the statistics, always the current year */
    year!: number;
    /** The number or active projects in the current year */
    activeProjectCount!: number;
    /** The number of closed projects in the current year */
    closedProjectCount!: number;
    /** The number of planned projects in the current year */
    plannedProjectCount!: number;
    /** The number of projects that are in transfer */
    inTransferProjectCount!: number;

    constructor(data?: IProjectStatisticsModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.activeProjectCount = _data["activeProjectCount"];
            this.closedProjectCount = _data["closedProjectCount"];
            this.plannedProjectCount = _data["plannedProjectCount"];
            this.inTransferProjectCount = _data["inTransferProjectCount"];
        }
    }

    static fromJS(data: any): ProjectStatisticsModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStatisticsModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["activeProjectCount"] = this.activeProjectCount;
        data["closedProjectCount"] = this.closedProjectCount;
        data["plannedProjectCount"] = this.plannedProjectCount;
        data["inTransferProjectCount"] = this.inTransferProjectCount;
        return data;
    }
}

/** Model to handle project statistics */
export interface IProjectStatisticsModel {
    /** The year for the statistics, always the current year */
    year: number;
    /** The number or active projects in the current year */
    activeProjectCount: number;
    /** The number of closed projects in the current year */
    closedProjectCount: number;
    /** The number of planned projects in the current year */
    plannedProjectCount: number;
    /** The number of projects that are in transfer */
    inTransferProjectCount: number;
}

/** Model to handle search filters */
export class ProjectFilterModel implements IProjectFilterModel {
    /** The Year for the filter */
    year?: number | undefined;
    /** The name or part of the name of a project - this will be searched using "like" */
    projectName?: string | undefined;
    /** The id of the advisor */
    advisorId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the state */
    stateId?: number | undefined;
    /** The id of the EnBW Unit */
    enBWUnitId?: number | undefined;
    /** The orga unit */
    orgaUnit?: string | undefined;
    /** A free text to search for in all fields of the project */
    freeText?: string | undefined;

    constructor(data?: IProjectFilterModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.projectName = _data["projectName"];
            this.advisorId = _data["advisorId"];
            this.projectManagerId = _data["projectManagerId"];
            this.stateId = _data["stateId"];
            this.enBWUnitId = _data["enBWUnitId"];
            this.orgaUnit = _data["orgaUnit"];
            this.freeText = _data["freeText"];
        }
    }

    static fromJS(data: any): ProjectFilterModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectFilterModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["projectName"] = this.projectName;
        data["advisorId"] = this.advisorId;
        data["projectManagerId"] = this.projectManagerId;
        data["stateId"] = this.stateId;
        data["enBWUnitId"] = this.enBWUnitId;
        data["orgaUnit"] = this.orgaUnit;
        data["freeText"] = this.freeText;
        return data;
    }
}

/** Model to handle search filters */
export interface IProjectFilterModel {
    /** The Year for the filter */
    year?: number | undefined;
    /** The name or part of the name of a project - this will be searched using "like" */
    projectName?: string | undefined;
    /** The id of the advisor */
    advisorId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the state */
    stateId?: number | undefined;
    /** The id of the EnBW Unit */
    enBWUnitId?: number | undefined;
    /** The orga unit */
    orgaUnit?: string | undefined;
    /** A free text to search for in all fields of the project */
    freeText?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfProjectModel extends DefaultRequestResult implements IRequestResultOfProjectModel {
    /** The payload (the result of the operation) */
    payload?: ProjectModel | undefined;

    constructor(data?: IRequestResultOfProjectModel) {
        super(data);
        if (data) {
            this.payload = data.payload && !(data.payload as any).toJSON ? new ProjectModel(data.payload) : this.payload as ProjectModel;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payload = _data["payload"] ? ProjectModel.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RequestResultOfProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfProjectModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfProjectModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectModel | undefined;
}

/** Result Data to return the project model */
export class ProjectResult extends RequestResultOfProjectModel implements IProjectResult {

    constructor(data?: IProjectResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return the project model */
export interface IProjectResult extends IRequestResultOfProjectModel {
}

/** The model for a single project including all the data */
export class ProjectModel implements IProjectModel {
    /** The id of the project */
    id!: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the transfer manager */
    transferManagerId?: number | undefined;
    /** The id of the project type */
    projectTypeId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The id of the TransferSuccess from Transfer */
    transferSuccessId?: number | undefined;
    /** The project number */
    number?: string | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date of the project */
    endDate?: moment.Moment | undefined;
    /** The phone number of the project manager (only if changed from the value in the users table) */
    projectManagerPhone?: string | undefined;
    /** The email of the project manager (only if changed from the value in the users table) */
    projectManagerEmail?: string | undefined;
    /** The fax number of the project manager (only if changed from the value in the users table) */
    projectManagerFax?: string | undefined;
    /** The phone number of the transfer manager (only if changed from the value in the users table) */
    transferManagerPhone?: string | undefined;
    /** The email of the transfer manager (only if changed from the value in the users table) */
    transferManagerEmail?: string | undefined;
    /** The fax number of the transfer manager (only if changed from the value in the users table) */
    transferManagerFax?: string | undefined;
    /** The commercial partners (just a text field) */
    commercialPartners?: string | undefined;
    /** The motivation for the project */
    motivation?: string | undefined;
    /** The utilization for the results of the project (verwertung der Ergebnisse) */
    utilization?: string | undefined;
    /** true if the project is transferable, false if not */
    isTransferable!: boolean;
    /** A number for the transfer progress (the id of the transfer progress) */
    transferResult?: string | undefined;
    /** The creation date for the project */
    creationDate?: moment.Moment | undefined;
    /** The id of the user that created the project */
    creationUserId?: number | undefined;
    /** The date of the application (Datum des Antrags) */
    applicationDate?: moment.Moment | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** Flag if the purchasing department was informed by mail */
    infoToPurchase!: boolean;
    /** The Organisation Unit for the Project */
    orgaUnit?: string | undefined;
    /** The ids of the academic partners. The complete list of academic partners is preloaded by the frontend */
    academicPartnerIds?: number[] | undefined;
    /** The ids of the public fundings. The complete list of public fundings is preloaded by the frontend */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags */
    tags?: TagModel[] | undefined;
    /** The Transfer-Unit for the project */
    transferUnit?: string | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;
    /** Bring popup to ask about sending the mail */
    readyForMailToPurchasing!: boolean;

    constructor(data?: IProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            if (data.tags) {
                this.tags = [];
                for (let i = 0; i < data.tags.length; i++) {
                    let item = data.tags[i];
                    this.tags[i] = item && !(item as any).toJSON ? new TagModel(item) : item as TagModel;
                }
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateId = _data["stateId"];
            this.projectManagerId = _data["projectManagerId"];
            this.transferManagerId = _data["transferManagerId"];
            this.projectTypeId = _data["projectTypeId"];
            this.enBWunitId = _data["enBWunitId"];
            this.transferSuccessId = _data["transferSuccessId"];
            this.number = _data["number"];
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.projectManagerPhone = _data["projectManagerPhone"];
            this.projectManagerEmail = _data["projectManagerEmail"];
            this.projectManagerFax = _data["projectManagerFax"];
            this.transferManagerPhone = _data["transferManagerPhone"];
            this.transferManagerEmail = _data["transferManagerEmail"];
            this.transferManagerFax = _data["transferManagerFax"];
            this.commercialPartners = _data["commercialPartners"];
            this.motivation = _data["motivation"];
            this.utilization = _data["utilization"];
            this.isTransferable = _data["isTransferable"];
            this.transferResult = _data["transferResult"];
            this.creationDate = _data["creationDate"] ? moment(_data["creationDate"].toString()) : undefined as any;
            this.creationUserId = _data["creationUserId"];
            this.applicationDate = _data["applicationDate"] ? moment(_data["applicationDate"].toString()) : undefined as any;
            this.advisorId = _data["advisorId"];
            this.infoToPurchase = _data["infoToPurchase"];
            this.orgaUnit = _data["orgaUnit"];
            if (Array.isArray(_data["academicPartnerIds"])) {
                this.academicPartnerIds = [] as any;
                for (let item of _data["academicPartnerIds"])
                    this.academicPartnerIds!.push(item);
            }
            if (Array.isArray(_data["publicFundingIds"])) {
                this.publicFundingIds = [] as any;
                for (let item of _data["publicFundingIds"])
                    this.publicFundingIds!.push(item);
            }
            this.timeWorkSchedule = _data["timeWorkSchedule"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(TagModel.fromJS(item));
            }
            this.transferUnit = _data["transferUnit"];
            this.projectWorkspaceUrl = _data["projectWorkspaceUrl"];
            this.readyForMailToPurchasing = _data["readyForMailToPurchasing"];
        }
    }

    static fromJS(data: any): ProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateId"] = this.stateId;
        data["projectManagerId"] = this.projectManagerId;
        data["transferManagerId"] = this.transferManagerId;
        data["projectTypeId"] = this.projectTypeId;
        data["enBWunitId"] = this.enBWunitId;
        data["transferSuccessId"] = this.transferSuccessId;
        data["number"] = this.number;
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["projectManagerPhone"] = this.projectManagerPhone;
        data["projectManagerEmail"] = this.projectManagerEmail;
        data["projectManagerFax"] = this.projectManagerFax;
        data["transferManagerPhone"] = this.transferManagerPhone;
        data["transferManagerEmail"] = this.transferManagerEmail;
        data["transferManagerFax"] = this.transferManagerFax;
        data["commercialPartners"] = this.commercialPartners;
        data["motivation"] = this.motivation;
        data["utilization"] = this.utilization;
        data["isTransferable"] = this.isTransferable;
        data["transferResult"] = this.transferResult;
        data["creationDate"] = this.creationDate ? this.creationDate.toISOString() : undefined as any;
        data["creationUserId"] = this.creationUserId;
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["advisorId"] = this.advisorId;
        data["infoToPurchase"] = this.infoToPurchase;
        data["orgaUnit"] = this.orgaUnit;
        if (Array.isArray(this.academicPartnerIds)) {
            data["academicPartnerIds"] = [];
            for (let item of this.academicPartnerIds)
                data["academicPartnerIds"].push(item);
        }
        if (Array.isArray(this.publicFundingIds)) {
            data["publicFundingIds"] = [];
            for (let item of this.publicFundingIds)
                data["publicFundingIds"].push(item);
        }
        data["timeWorkSchedule"] = this.timeWorkSchedule;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item ? item.toJSON() : undefined as any);
        }
        data["transferUnit"] = this.transferUnit;
        data["projectWorkspaceUrl"] = this.projectWorkspaceUrl;
        data["readyForMailToPurchasing"] = this.readyForMailToPurchasing;
        return data;
    }
}

/** The model for a single project including all the data */
export interface IProjectModel {
    /** The id of the project */
    id: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the transfer manager */
    transferManagerId?: number | undefined;
    /** The id of the project type */
    projectTypeId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The id of the TransferSuccess from Transfer */
    transferSuccessId?: number | undefined;
    /** The project number */
    number?: string | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date of the project */
    endDate?: moment.Moment | undefined;
    /** The phone number of the project manager (only if changed from the value in the users table) */
    projectManagerPhone?: string | undefined;
    /** The email of the project manager (only if changed from the value in the users table) */
    projectManagerEmail?: string | undefined;
    /** The fax number of the project manager (only if changed from the value in the users table) */
    projectManagerFax?: string | undefined;
    /** The phone number of the transfer manager (only if changed from the value in the users table) */
    transferManagerPhone?: string | undefined;
    /** The email of the transfer manager (only if changed from the value in the users table) */
    transferManagerEmail?: string | undefined;
    /** The fax number of the transfer manager (only if changed from the value in the users table) */
    transferManagerFax?: string | undefined;
    /** The commercial partners (just a text field) */
    commercialPartners?: string | undefined;
    /** The motivation for the project */
    motivation?: string | undefined;
    /** The utilization for the results of the project (verwertung der Ergebnisse) */
    utilization?: string | undefined;
    /** true if the project is transferable, false if not */
    isTransferable: boolean;
    /** A number for the transfer progress (the id of the transfer progress) */
    transferResult?: string | undefined;
    /** The creation date for the project */
    creationDate?: moment.Moment | undefined;
    /** The id of the user that created the project */
    creationUserId?: number | undefined;
    /** The date of the application (Datum des Antrags) */
    applicationDate?: moment.Moment | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** Flag if the purchasing department was informed by mail */
    infoToPurchase: boolean;
    /** The Organisation Unit for the Project */
    orgaUnit?: string | undefined;
    /** The ids of the academic partners. The complete list of academic partners is preloaded by the frontend */
    academicPartnerIds?: number[] | undefined;
    /** The ids of the public fundings. The complete list of public fundings is preloaded by the frontend */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags */
    tags?: ITagModel[] | undefined;
    /** The Transfer-Unit for the project */
    transferUnit?: string | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;
    /** Bring popup to ask about sending the mail */
    readyForMailToPurchasing: boolean;
}

/** The model for a tag */
export class TagModel implements ITagModel {
    /** The id for the tag, only used internally for assignment */
    id!: number;
    /** The name of the tag */
    name?: string | undefined;

    constructor(data?: ITagModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): TagModel {
        data = typeof data === 'object' ? data : {};
        let result = new TagModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** The model for a tag */
export interface ITagModel {
    /** The id for the tag, only used internally for assignment */
    id: number;
    /** The name of the tag */
    name?: string | undefined;
}

/** Model to handle inserting new projects */
export class InsertProjectModel implements IInsertProjectModel {
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the project type
             */
    projectTypeId?: number | undefined;
    /** The id of the EnBWUnit */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** true if transferable, false if not */
    isTransferable!: boolean;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date (due date) of the project */
    endDate?: moment.Moment | undefined;
    /** Phone number of the project manager */
    projectManagerPhone?: string | undefined;
    /** Email of the project manager */
    projectManagerEmail?: string | undefined;
    /** Fax of the project manager */
    projectManagerFax?: string | undefined;
    /** Kommerzielle Partner */
    commercialPartners?: string | undefined;
    /** Motivation */
    motivation?: string | undefined;
    /** Is that the planned disposal? */
    utilization?: string | undefined;
    /** The list of ids of academic partners */
    academicPartnerIds?: number[] | undefined;
    /** The list of ids for public fundings */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags for the Project */
    tags?: string[] | undefined;
    /** The id of the advisor (Betreuer) */
    advisorId?: number | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;

    constructor(data?: IInsertProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectManagerId = _data["projectManagerId"];
            this.projectTypeId = _data["projectTypeId"];
            this.enBWunitId = _data["enBWunitId"];
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            this.isTransferable = _data["isTransferable"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.projectManagerPhone = _data["projectManagerPhone"];
            this.projectManagerEmail = _data["projectManagerEmail"];
            this.projectManagerFax = _data["projectManagerFax"];
            this.commercialPartners = _data["commercialPartners"];
            this.motivation = _data["motivation"];
            this.utilization = _data["utilization"];
            if (Array.isArray(_data["academicPartnerIds"])) {
                this.academicPartnerIds = [] as any;
                for (let item of _data["academicPartnerIds"])
                    this.academicPartnerIds!.push(item);
            }
            if (Array.isArray(_data["publicFundingIds"])) {
                this.publicFundingIds = [] as any;
                for (let item of _data["publicFundingIds"])
                    this.publicFundingIds!.push(item);
            }
            this.timeWorkSchedule = _data["timeWorkSchedule"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.advisorId = _data["advisorId"];
            this.orgaUnit = _data["orgaUnit"];
            this.projectWorkspaceUrl = _data["projectWorkspaceUrl"];
        }
    }

    static fromJS(data: any): InsertProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectManagerId"] = this.projectManagerId;
        data["projectTypeId"] = this.projectTypeId;
        data["enBWunitId"] = this.enBWunitId;
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        data["isTransferable"] = this.isTransferable;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["projectManagerPhone"] = this.projectManagerPhone;
        data["projectManagerEmail"] = this.projectManagerEmail;
        data["projectManagerFax"] = this.projectManagerFax;
        data["commercialPartners"] = this.commercialPartners;
        data["motivation"] = this.motivation;
        data["utilization"] = this.utilization;
        if (Array.isArray(this.academicPartnerIds)) {
            data["academicPartnerIds"] = [];
            for (let item of this.academicPartnerIds)
                data["academicPartnerIds"].push(item);
        }
        if (Array.isArray(this.publicFundingIds)) {
            data["publicFundingIds"] = [];
            for (let item of this.publicFundingIds)
                data["publicFundingIds"].push(item);
        }
        data["timeWorkSchedule"] = this.timeWorkSchedule;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["advisorId"] = this.advisorId;
        data["orgaUnit"] = this.orgaUnit;
        data["projectWorkspaceUrl"] = this.projectWorkspaceUrl;
        return data;
    }
}

/** Model to handle inserting new projects */
export interface IInsertProjectModel {
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the project type
             */
    projectTypeId?: number | undefined;
    /** The id of the EnBWUnit */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** true if transferable, false if not */
    isTransferable: boolean;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date (due date) of the project */
    endDate?: moment.Moment | undefined;
    /** Phone number of the project manager */
    projectManagerPhone?: string | undefined;
    /** Email of the project manager */
    projectManagerEmail?: string | undefined;
    /** Fax of the project manager */
    projectManagerFax?: string | undefined;
    /** Kommerzielle Partner */
    commercialPartners?: string | undefined;
    /** Motivation */
    motivation?: string | undefined;
    /** Is that the planned disposal? */
    utilization?: string | undefined;
    /** The list of ids of academic partners */
    academicPartnerIds?: number[] | undefined;
    /** The list of ids for public fundings */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags for the Project */
    tags?: string[] | undefined;
    /** The id of the advisor (Betreuer) */
    advisorId?: number | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;
}

/** Model to handle project updates */
export class UpdateProjectModel implements IUpdateProjectModel {
    /** The id of the project */
    id!: number;
    /** The id of the transfer manager */
    transferManagerId?: number | undefined;
    /** The id of the project type
             */
    projectTypeId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** true if transferable, false if not */
    isTransferable!: boolean;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date (due date) of the project */
    endDate?: moment.Moment | undefined;
    /** Phone number of the project manager */
    transferManagerPhone?: string | undefined;
    /** Email of the project manager */
    transferManagerEmail?: string | undefined;
    /** Fax of the project manager */
    transferManagerFax?: string | undefined;
    /** Kommerzielle Partner */
    commercialPartners?: string | undefined;
    /** Motivation */
    motivation?: string | undefined;
    /** Is that the planned disposal? */
    utilization?: string | undefined;
    /** The list of ids of academic partners */
    academicPartnerIds?: number[] | undefined;
    /** The list of ids for public fundings */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags for the Project */
    tags?: string[] | undefined;
    /** The application date (anlagedatum) */
    applicationDate?: moment.Moment | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
    /** The Transfer-Unit for the project */
    transferUnit?: string | undefined;
    /** A number for the transfer progress (the id of the transfer progress) */
    transferResult?: string | undefined;
    /** The id of the TransferSuccess from Transfer */
    transferSuccessId?: number | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;

    constructor(data?: IUpdateProjectModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.transferManagerId = _data["transferManagerId"];
            this.projectTypeId = _data["projectTypeId"];
            this.name = _data["name"];
            this.shortDescription = _data["shortDescription"];
            this.isTransferable = _data["isTransferable"];
            this.startDate = _data["startDate"] ? moment(_data["startDate"].toString()) : undefined as any;
            this.endDate = _data["endDate"] ? moment(_data["endDate"].toString()) : undefined as any;
            this.transferManagerPhone = _data["transferManagerPhone"];
            this.transferManagerEmail = _data["transferManagerEmail"];
            this.transferManagerFax = _data["transferManagerFax"];
            this.commercialPartners = _data["commercialPartners"];
            this.motivation = _data["motivation"];
            this.utilization = _data["utilization"];
            if (Array.isArray(_data["academicPartnerIds"])) {
                this.academicPartnerIds = [] as any;
                for (let item of _data["academicPartnerIds"])
                    this.academicPartnerIds!.push(item);
            }
            if (Array.isArray(_data["publicFundingIds"])) {
                this.publicFundingIds = [] as any;
                for (let item of _data["publicFundingIds"])
                    this.publicFundingIds!.push(item);
            }
            this.timeWorkSchedule = _data["timeWorkSchedule"];
            if (Array.isArray(_data["tags"])) {
                this.tags = [] as any;
                for (let item of _data["tags"])
                    this.tags!.push(item);
            }
            this.applicationDate = _data["applicationDate"] ? moment(_data["applicationDate"].toString()) : undefined as any;
            this.orgaUnit = _data["orgaUnit"];
            this.transferUnit = _data["transferUnit"];
            this.transferResult = _data["transferResult"];
            this.transferSuccessId = _data["transferSuccessId"];
            this.projectWorkspaceUrl = _data["projectWorkspaceUrl"];
        }
    }

    static fromJS(data: any): UpdateProjectModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["transferManagerId"] = this.transferManagerId;
        data["projectTypeId"] = this.projectTypeId;
        data["name"] = this.name;
        data["shortDescription"] = this.shortDescription;
        data["isTransferable"] = this.isTransferable;
        data["startDate"] = this.startDate ? this.startDate.toISOString() : undefined as any;
        data["endDate"] = this.endDate ? this.endDate.toISOString() : undefined as any;
        data["transferManagerPhone"] = this.transferManagerPhone;
        data["transferManagerEmail"] = this.transferManagerEmail;
        data["transferManagerFax"] = this.transferManagerFax;
        data["commercialPartners"] = this.commercialPartners;
        data["motivation"] = this.motivation;
        data["utilization"] = this.utilization;
        if (Array.isArray(this.academicPartnerIds)) {
            data["academicPartnerIds"] = [];
            for (let item of this.academicPartnerIds)
                data["academicPartnerIds"].push(item);
        }
        if (Array.isArray(this.publicFundingIds)) {
            data["publicFundingIds"] = [];
            for (let item of this.publicFundingIds)
                data["publicFundingIds"].push(item);
        }
        data["timeWorkSchedule"] = this.timeWorkSchedule;
        if (Array.isArray(this.tags)) {
            data["tags"] = [];
            for (let item of this.tags)
                data["tags"].push(item);
        }
        data["applicationDate"] = this.applicationDate ? this.applicationDate.toISOString() : undefined as any;
        data["orgaUnit"] = this.orgaUnit;
        data["transferUnit"] = this.transferUnit;
        data["transferResult"] = this.transferResult;
        data["transferSuccessId"] = this.transferSuccessId;
        data["projectWorkspaceUrl"] = this.projectWorkspaceUrl;
        return data;
    }
}

/** Model to handle project updates */
export interface IUpdateProjectModel {
    /** The id of the project */
    id: number;
    /** The id of the transfer manager */
    transferManagerId?: number | undefined;
    /** The id of the project type
             */
    projectTypeId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The description of the project */
    shortDescription?: string | undefined;
    /** true if transferable, false if not */
    isTransferable: boolean;
    /** The start date of the project */
    startDate?: moment.Moment | undefined;
    /** The end date (due date) of the project */
    endDate?: moment.Moment | undefined;
    /** Phone number of the project manager */
    transferManagerPhone?: string | undefined;
    /** Email of the project manager */
    transferManagerEmail?: string | undefined;
    /** Fax of the project manager */
    transferManagerFax?: string | undefined;
    /** Kommerzielle Partner */
    commercialPartners?: string | undefined;
    /** Motivation */
    motivation?: string | undefined;
    /** Is that the planned disposal? */
    utilization?: string | undefined;
    /** The list of ids of academic partners */
    academicPartnerIds?: number[] | undefined;
    /** The list of ids for public fundings */
    publicFundingIds?: number[] | undefined;
    /** Zeit- und Arbeitsplan */
    timeWorkSchedule?: string | undefined;
    /** The list of tags for the Project */
    tags?: string[] | undefined;
    /** The application date (anlagedatum) */
    applicationDate?: moment.Moment | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
    /** The Transfer-Unit for the project */
    transferUnit?: string | undefined;
    /** A number for the transfer progress (the id of the transfer progress) */
    transferResult?: string | undefined;
    /** The id of the TransferSuccess from Transfer */
    transferSuccessId?: number | undefined;
    /** Link to the teams workspace containing all the project documentation */
    projectWorkspaceUrl?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfProjectHeaderModel extends DefaultRequestResult implements IRequestResultOfProjectHeaderModel {
    /** The payload (the result of the operation) */
    payload?: ProjectHeaderModel | undefined;

    constructor(data?: IRequestResultOfProjectHeaderModel) {
        super(data);
        if (data) {
            this.payload = data.payload && !(data.payload as any).toJSON ? new ProjectHeaderModel(data.payload) : this.payload as ProjectHeaderModel;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payload = _data["payload"] ? ProjectHeaderModel.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RequestResultOfProjectHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfProjectHeaderModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfProjectHeaderModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectHeaderModel | undefined;
}

/** Result Data to return the project header */
export class ProjectHeaderResult extends RequestResultOfProjectHeaderModel implements IProjectHeaderResult {

    constructor(data?: IProjectHeaderResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectHeaderResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHeaderResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return the project header */
export interface IProjectHeaderResult extends IRequestResultOfProjectHeaderModel {
}

/** The model for the header data of a project */
export class ProjectHeaderModel implements IProjectHeaderModel {
    /** The id of the project */
    id!: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The project number */
    number?: string | undefined;
    /** The phone number of the project manager (only if changed from the value in the users table) */
    projectManagerPhone?: string | undefined;
    /** The email of the project manager (only if changed from the value in the users table) */
    projectManagerEmail?: string | undefined;
    /** The fax number of the project manager (only if changed from the value in the users table) */
    projectManagerFax?: string | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** The advisor (Betreuer) */
    advisor?: UserModel | undefined;
    /** The EnBWUnit responsible for the project */
    enBWunit?: EnBWUnitModel | undefined;
    /** The project manager */
    projectManager?: UserModel | undefined;
    /** The project state */
    state?: ProjectStateModel | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;

    constructor(data?: IProjectHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
            this.advisor = data.advisor && !(data.advisor as any).toJSON ? new UserModel(data.advisor) : this.advisor as UserModel;
            this.enBWunit = data.enBWunit && !(data.enBWunit as any).toJSON ? new EnBWUnitModel(data.enBWunit) : this.enBWunit as EnBWUnitModel;
            this.projectManager = data.projectManager && !(data.projectManager as any).toJSON ? new UserModel(data.projectManager) : this.projectManager as UserModel;
            this.state = data.state && !(data.state as any).toJSON ? new ProjectStateModel(data.state) : this.state as ProjectStateModel;
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateId = _data["stateId"];
            this.projectManagerId = _data["projectManagerId"];
            this.enBWunitId = _data["enBWunitId"];
            this.name = _data["name"];
            this.number = _data["number"];
            this.projectManagerPhone = _data["projectManagerPhone"];
            this.projectManagerEmail = _data["projectManagerEmail"];
            this.projectManagerFax = _data["projectManagerFax"];
            this.advisorId = _data["advisorId"];
            this.advisor = _data["advisor"] ? UserModel.fromJS(_data["advisor"]) : undefined as any;
            this.enBWunit = _data["enBWunit"] ? EnBWUnitModel.fromJS(_data["enBWunit"]) : undefined as any;
            this.projectManager = _data["projectManager"] ? UserModel.fromJS(_data["projectManager"]) : undefined as any;
            this.state = _data["state"] ? ProjectStateModel.fromJS(_data["state"]) : undefined as any;
            this.orgaUnit = _data["orgaUnit"];
        }
    }

    static fromJS(data: any): ProjectHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateId"] = this.stateId;
        data["projectManagerId"] = this.projectManagerId;
        data["enBWunitId"] = this.enBWunitId;
        data["name"] = this.name;
        data["number"] = this.number;
        data["projectManagerPhone"] = this.projectManagerPhone;
        data["projectManagerEmail"] = this.projectManagerEmail;
        data["projectManagerFax"] = this.projectManagerFax;
        data["advisorId"] = this.advisorId;
        data["advisor"] = this.advisor ? this.advisor.toJSON() : undefined as any;
        data["enBWunit"] = this.enBWunit ? this.enBWunit.toJSON() : undefined as any;
        data["projectManager"] = this.projectManager ? this.projectManager.toJSON() : undefined as any;
        data["state"] = this.state ? this.state.toJSON() : undefined as any;
        data["orgaUnit"] = this.orgaUnit;
        return data;
    }
}

/** The model for the header data of a project */
export interface IProjectHeaderModel {
    /** The id of the project */
    id: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the ENBwUnit responsible for the project */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** The project number */
    number?: string | undefined;
    /** The phone number of the project manager (only if changed from the value in the users table) */
    projectManagerPhone?: string | undefined;
    /** The email of the project manager (only if changed from the value in the users table) */
    projectManagerEmail?: string | undefined;
    /** The fax number of the project manager (only if changed from the value in the users table) */
    projectManagerFax?: string | undefined;
    /** The id of the project advisor */
    advisorId?: number | undefined;
    /** The advisor (Betreuer) */
    advisor?: IUserModel | undefined;
    /** The EnBWUnit responsible for the project */
    enBWunit?: IEnBWUnitModel | undefined;
    /** The project manager */
    projectManager?: IUserModel | undefined;
    /** The project state */
    state?: IProjectStateModel | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
}

/** Model to handle project header updates */
export class UpdateProjectHeaderModel implements IUpdateProjectHeaderModel {
    /** The id of the project */
    id!: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the EnBWUnit */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** Phone number of the project manager */
    projectManagerPhone?: string | undefined;
    /** Email of the project manager */
    projectManagerEmail?: string | undefined;
    /** Fax of the project manager */
    projectManagerFax?: string | undefined;
    /** The id of the advisor (Betreuer) */
    advisorId?: number | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;

    constructor(data?: IUpdateProjectHeaderModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.stateId = _data["stateId"];
            this.projectManagerId = _data["projectManagerId"];
            this.enBWunitId = _data["enBWunitId"];
            this.name = _data["name"];
            this.projectManagerPhone = _data["projectManagerPhone"];
            this.projectManagerEmail = _data["projectManagerEmail"];
            this.projectManagerFax = _data["projectManagerFax"];
            this.advisorId = _data["advisorId"];
            this.orgaUnit = _data["orgaUnit"];
        }
    }

    static fromJS(data: any): UpdateProjectHeaderModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateProjectHeaderModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["stateId"] = this.stateId;
        data["projectManagerId"] = this.projectManagerId;
        data["enBWunitId"] = this.enBWunitId;
        data["name"] = this.name;
        data["projectManagerPhone"] = this.projectManagerPhone;
        data["projectManagerEmail"] = this.projectManagerEmail;
        data["projectManagerFax"] = this.projectManagerFax;
        data["advisorId"] = this.advisorId;
        data["orgaUnit"] = this.orgaUnit;
        return data;
    }
}

/** Model to handle project header updates */
export interface IUpdateProjectHeaderModel {
    /** The id of the project */
    id: number;
    /** The id of the state of the project */
    stateId?: number | undefined;
    /** The id of the project manager */
    projectManagerId?: number | undefined;
    /** The id of the EnBWUnit */
    enBWunitId?: number | undefined;
    /** The name of the project */
    name?: string | undefined;
    /** Phone number of the project manager */
    projectManagerPhone?: string | undefined;
    /** Email of the project manager */
    projectManagerEmail?: string | undefined;
    /** Fax of the project manager */
    projectManagerFax?: string | undefined;
    /** The id of the advisor (Betreuer) */
    advisorId?: number | undefined;
    /** The Orga-Unit for the project */
    orgaUnit?: string | undefined;
}

/** The model for updating the state */
export class UpdateStateModel implements IUpdateStateModel {
    /** The id of the project whose state should be changed */
    projectId!: number;
    /** The id of the state the project should be put in */
    targetStateId!: number;

    constructor(data?: IUpdateStateModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.targetStateId = _data["targetStateId"];
        }
    }

    static fromJS(data: any): UpdateStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateStateModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["targetStateId"] = this.targetStateId;
        return data;
    }
}

/** The model for updating the state */
export interface IUpdateStateModel {
    /** The id of the project whose state should be changed */
    projectId: number;
    /** The id of the state the project should be put in */
    targetStateId: number;
}

/** The model for requesting a project to be started */
export class ProjectRequestModel implements IProjectRequestModel {
    /** The id of the project that is requested */
    projectId!: number;
    /** The id of the current project status */
    stateId!: number;
    /** The message to management */
    requestMsg?: string | undefined;

    constructor(data?: IProjectRequestModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.stateId = _data["stateId"];
            this.requestMsg = _data["requestMsg"];
        }
    }

    static fromJS(data: any): ProjectRequestModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectRequestModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["stateId"] = this.stateId;
        data["requestMsg"] = this.requestMsg;
        return data;
    }
}

/** The model for requesting a project to be started */
export interface IProjectRequestModel {
    /** The id of the project that is requested */
    projectId: number;
    /** The id of the current project status */
    stateId: number;
    /** The message to management */
    requestMsg?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfProjectStateModel extends DefaultRequestResult implements IRequestResultOfListOfProjectStateModel {
    /** The payload (the result of the operation) */
    payload?: ProjectStateModel[] | undefined;

    constructor(data?: IRequestResultOfListOfProjectStateModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new ProjectStateModel(item) : item as ProjectStateModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(ProjectStateModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfProjectStateModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfProjectStateModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfProjectStateModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectStateModel[] | undefined;
}

/** The result class for a list of project states */
export class ProjectStateListResult extends RequestResultOfListOfProjectStateModel implements IProjectStateListResult {

    constructor(data?: IProjectStateListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectStateListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectStateListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result class for a list of project states */
export interface IProjectStateListResult extends IRequestResultOfListOfProjectStateModel {
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfProjectTypeModel extends DefaultRequestResult implements IRequestResultOfListOfProjectTypeModel {
    /** The payload (the result of the operation) */
    payload?: ProjectTypeModel[] | undefined;

    constructor(data?: IRequestResultOfListOfProjectTypeModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new ProjectTypeModel(item) : item as ProjectTypeModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(ProjectTypeModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfProjectTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfProjectTypeModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfProjectTypeModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IProjectTypeModel[] | undefined;
}

/** The result class for a list of project types */
export class ProjectTypeListResult extends RequestResultOfListOfProjectTypeModel implements IProjectTypeListResult {

    constructor(data?: IProjectTypeListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): ProjectTypeListResult {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result class for a list of project types */
export interface IProjectTypeListResult extends IRequestResultOfListOfProjectTypeModel {
}

/** The model for the project type */
export class ProjectTypeModel implements IProjectTypeModel {
    /** The id of the project type */
    id!: number;
    /** The name of the project type */
    name?: string | undefined;
    /** true if the project type is active, false if not */
    isActive!: boolean;

    constructor(data?: IProjectTypeModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): ProjectTypeModel {
        data = typeof data === 'object' ? data : {};
        let result = new ProjectTypeModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** The model for the project type */
export interface IProjectTypeModel {
    /** The id of the project type */
    id: number;
    /** The name of the project type */
    name?: string | undefined;
    /** true if the project type is active, false if not */
    isActive: boolean;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfPublicFundingModel extends DefaultRequestResult implements IRequestResultOfListOfPublicFundingModel {
    /** The payload (the result of the operation) */
    payload?: PublicFundingModel[] | undefined;

    constructor(data?: IRequestResultOfListOfPublicFundingModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new PublicFundingModel(item) : item as PublicFundingModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(PublicFundingModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfPublicFundingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfPublicFundingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfPublicFundingModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IPublicFundingModel[] | undefined;
}

/** The result model for a list of PublicFundingModel objects */
export class PublicFundingListResult extends RequestResultOfListOfPublicFundingModel implements IPublicFundingListResult {

    constructor(data?: IPublicFundingListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): PublicFundingListResult {
        data = typeof data === 'object' ? data : {};
        let result = new PublicFundingListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result model for a list of PublicFundingModel objects */
export interface IPublicFundingListResult extends IRequestResultOfListOfPublicFundingModel {
}

/** Model to handle public funding */
export class PublicFundingModel implements IPublicFundingModel {
    /** The id of the public funding */
    id!: number;
    /** The name of the public funding */
    name?: string | undefined;
    /** true if the public funding is active, false if not */
    isActive!: boolean;

    constructor(data?: IPublicFundingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): PublicFundingModel {
        data = typeof data === 'object' ? data : {};
        let result = new PublicFundingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** Model to handle public funding */
export interface IPublicFundingModel {
    /** The id of the public funding */
    id: number;
    /** The name of the public funding */
    name?: string | undefined;
    /** true if the public funding is active, false if not */
    isActive: boolean;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfRiskRatingModel extends DefaultRequestResult implements IRequestResultOfListOfRiskRatingModel {
    /** The payload (the result of the operation) */
    payload?: RiskRatingModel[] | undefined;

    constructor(data?: IRequestResultOfListOfRiskRatingModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new RiskRatingModel(item) : item as RiskRatingModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(RiskRatingModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfRiskRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfRiskRatingModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfRiskRatingModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IRiskRatingModel[] | undefined;
}

/** The data object for the list of risk ratings */
export class RiskRatingListResult extends RequestResultOfListOfRiskRatingModel implements IRiskRatingListResult {

    constructor(data?: IRiskRatingListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RiskRatingListResult {
        data = typeof data === 'object' ? data : {};
        let result = new RiskRatingListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The data object for the list of risk ratings */
export interface IRiskRatingListResult extends IRequestResultOfListOfRiskRatingModel {
}

/** The model for the risk ratings */
export class RiskRatingModel implements IRiskRatingModel {
    /** The id of the risk rating */
    id!: number;
    /** The name of the risk rating */
    name?: string | undefined;

    constructor(data?: IRiskRatingModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): RiskRatingModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskRatingModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

/** The model for the risk ratings */
export interface IRiskRatingModel {
    /** The id of the risk rating */
    id: number;
    /** The name of the risk rating */
    name?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfRiskModel extends DefaultRequestResult implements IRequestResultOfListOfRiskModel {
    /** The payload (the result of the operation) */
    payload?: RiskModel[] | undefined;

    constructor(data?: IRequestResultOfListOfRiskModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new RiskModel(item) : item as RiskModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(RiskModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfRiskModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfRiskModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfRiskModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IRiskModel[] | undefined;
}

/** The model for the list of risks for a project */
export class RiskListResult extends RequestResultOfListOfRiskModel implements IRiskListResult {

    constructor(data?: IRiskListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): RiskListResult {
        data = typeof data === 'object' ? data : {};
        let result = new RiskListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The model for the list of risks for a project */
export interface IRiskListResult extends IRequestResultOfListOfRiskModel {
}

/** Model to handle project risks */
export class RiskModel implements IRiskModel {
    /** The id of the risk */
    id!: number;
    /** The id of the project the risk belongs to */
    projectId!: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId!: number;
    /** The impact of the risk */
    impact?: string | undefined;

    constructor(data?: IRiskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.riskRatingId = _data["riskRatingId"];
            this.impact = _data["impact"];
        }
    }

    static fromJS(data: any): RiskModel {
        data = typeof data === 'object' ? data : {};
        let result = new RiskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["riskRatingId"] = this.riskRatingId;
        data["impact"] = this.impact;
        return data;
    }
}

/** Model to handle project risks */
export interface IRiskModel {
    /** The id of the risk */
    id: number;
    /** The id of the project the risk belongs to */
    projectId: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId: number;
    /** The impact of the risk */
    impact?: string | undefined;
}

/** The model to insert a risk */
export class InsertRiskModel implements IInsertRiskModel {
    /** The id of the project the risk belongs to */
    projectId!: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId!: number;
    /** The impact of the risk */
    impact?: string | undefined;

    constructor(data?: IInsertRiskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.riskRatingId = _data["riskRatingId"];
            this.impact = _data["impact"];
        }
    }

    static fromJS(data: any): InsertRiskModel {
        data = typeof data === 'object' ? data : {};
        let result = new InsertRiskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["riskRatingId"] = this.riskRatingId;
        data["impact"] = this.impact;
        return data;
    }
}

/** The model to insert a risk */
export interface IInsertRiskModel {
    /** The id of the project the risk belongs to */
    projectId: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId: number;
    /** The impact of the risk */
    impact?: string | undefined;
}

/** The model to update a risk */
export class UpdateRiskModel implements IUpdateRiskModel {
    /** The id of the risk */
    id!: number;
    /** The id of the project the risk belongs to */
    projectId!: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId!: number;
    /** The impact of the risk */
    impact?: string | undefined;

    constructor(data?: IUpdateRiskModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.projectId = _data["projectId"];
            this.name = _data["name"];
            this.riskRatingId = _data["riskRatingId"];
            this.impact = _data["impact"];
        }
    }

    static fromJS(data: any): UpdateRiskModel {
        data = typeof data === 'object' ? data : {};
        let result = new UpdateRiskModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["projectId"] = this.projectId;
        data["name"] = this.name;
        data["riskRatingId"] = this.riskRatingId;
        data["impact"] = this.impact;
        return data;
    }
}

/** The model to update a risk */
export interface IUpdateRiskModel {
    /** The id of the risk */
    id: number;
    /** The id of the project the risk belongs to */
    projectId: number;
    /** The name of the risk */
    name?: string | undefined;
    /** The rating of the risk */
    riskRatingId: number;
    /** The impact of the risk */
    impact?: string | undefined;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfTagModel extends DefaultRequestResult implements IRequestResultOfListOfTagModel {
    /** The payload (the result of the operation) */
    payload?: TagModel[] | undefined;

    constructor(data?: IRequestResultOfListOfTagModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new TagModel(item) : item as TagModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(TagModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfTagModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfTagModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfTagModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: ITagModel[] | undefined;
}

/** The result object for a list of tags */
export class TagListResult extends RequestResultOfListOfTagModel implements ITagListResult {

    constructor(data?: ITagListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TagListResult {
        data = typeof data === 'object' ? data : {};
        let result = new TagListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for a list of tags */
export interface ITagListResult extends IRequestResultOfListOfTagModel {
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfTransferSuccessModel extends DefaultRequestResult implements IRequestResultOfListOfTransferSuccessModel {
    /** The payload (the result of the operation) */
    payload?: TransferSuccessModel[] | undefined;

    constructor(data?: IRequestResultOfListOfTransferSuccessModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new TransferSuccessModel(item) : item as TransferSuccessModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(TransferSuccessModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfTransferSuccessModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfTransferSuccessModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfTransferSuccessModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: ITransferSuccessModel[] | undefined;
}

/** The result object for the Cost request */
export class TransferSuccessListResult extends RequestResultOfListOfTransferSuccessModel implements ITransferSuccessListResult {

    constructor(data?: ITransferSuccessListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): TransferSuccessListResult {
        data = typeof data === 'object' ? data : {};
        let result = new TransferSuccessListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for the Cost request */
export interface ITransferSuccessListResult extends IRequestResultOfListOfTransferSuccessModel {
}

/** the data object for Transfer Success */
export class TransferSuccessModel implements ITransferSuccessModel {
    /** the id from the Transfer Success */
    id!: number;
    /** The name form the Transfer Success */
    name?: string | undefined;
    /** This allows you to set a value to inactive. */
    isActive!: boolean;

    constructor(data?: ITransferSuccessModel) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (this as any)[property] = (data as any)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.isActive = _data["isActive"];
        }
    }

    static fromJS(data: any): TransferSuccessModel {
        data = typeof data === 'object' ? data : {};
        let result = new TransferSuccessModel();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["isActive"] = this.isActive;
        return data;
    }
}

/** the data object for Transfer Success */
export interface ITransferSuccessModel {
    /** the id from the Transfer Success */
    id: number;
    /** The name form the Transfer Success */
    name?: string | undefined;
    /** This allows you to set a value to inactive. */
    isActive: boolean;
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfListOfUserModel extends DefaultRequestResult implements IRequestResultOfListOfUserModel {
    /** The payload (the result of the operation) */
    payload?: UserModel[] | undefined;

    constructor(data?: IRequestResultOfListOfUserModel) {
        super(data);
        if (data) {
            if (data.payload) {
                this.payload = [];
                for (let i = 0; i < data.payload.length; i++) {
                    let item = data.payload[i];
                    this.payload[i] = item && !(item as any).toJSON ? new UserModel(item) : item as UserModel;
                }
            }
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            if (Array.isArray(_data["payload"])) {
                this.payload = [] as any;
                for (let item of _data["payload"])
                    this.payload!.push(UserModel.fromJS(item));
            }
        }
    }

    static override fromJS(data: any): RequestResultOfListOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfListOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.payload)) {
            data["payload"] = [];
            for (let item of this.payload)
                data["payload"].push(item ? item.toJSON() : undefined as any);
        }
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfListOfUserModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IUserModel[] | undefined;
}

/** The result object for the User request */
export class UserListResult extends RequestResultOfListOfUserModel implements IUserListResult {

    constructor(data?: IUserListResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserListResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserListResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** The result object for the User request */
export interface IUserListResult extends IRequestResultOfListOfUserModel {
}

/** The request result. All results are returned as a type of this class */
export class RequestResultOfUserModel extends DefaultRequestResult implements IRequestResultOfUserModel {
    /** The payload (the result of the operation) */
    payload?: UserModel | undefined;

    constructor(data?: IRequestResultOfUserModel) {
        super(data);
        if (data) {
            this.payload = data.payload && !(data.payload as any).toJSON ? new UserModel(data.payload) : this.payload as UserModel;
        }
    }

    override init(_data?: any) {
        super.init(_data);
        if (_data) {
            this.payload = _data["payload"] ? UserModel.fromJS(_data["payload"]) : undefined as any;
        }
    }

    static override fromJS(data: any): RequestResultOfUserModel {
        data = typeof data === 'object' ? data : {};
        let result = new RequestResultOfUserModel();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["payload"] = this.payload ? this.payload.toJSON() : undefined as any;
        super.toJSON(data);
        return data;
    }
}

/** The request result. All results are returned as a type of this class */
export interface IRequestResultOfUserModel extends IDefaultRequestResult {
    /** The payload (the result of the operation) */
    payload?: IUserModel | undefined;
}

/** Result Data to return user information */
export class UserResult extends RequestResultOfUserModel implements IUserResult {

    constructor(data?: IUserResult) {
        super(data);
    }

    override init(_data?: any) {
        super.init(_data);
    }

    static override fromJS(data: any): UserResult {
        data = typeof data === 'object' ? data : {};
        let result = new UserResult();
        result.init(data);
        return result;
    }

    override toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        super.toJSON(data);
        return data;
    }
}

/** Result Data to return user information */
export interface IUserResult extends IRequestResultOfUserModel {
}

export interface FileResponse {
    data: Blob;
    status: number;
    fileName?: string;
    headers?: { [name: string]: any };
}

export class ApiException extends Error {
    override message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): Observable<any> {
    if (result !== null && result !== undefined)
        return _observableThrow(result);
    else
        return _observableThrow(new ApiException(message, status, response, headers, null));
}

function blobToText(blob: any): Observable<string> {
    return new Observable<string>((observer: any) => {
        if (!blob) {
            observer.next("");
            observer.complete();
        } else {
            let reader = new FileReader();
            reader.onload = event => {
                observer.next((event.target as any).result);
                observer.complete();
            };
            reader.readAsText(blob);
        }
    });
}